import type { Translations } from "./types";

export const ar: Translations = {
  // ── Navigation ──────────────────────────────────────────────────────────────
  "nav.home": "الرئيسية",
  "nav.about": "عن أرتيريا",
  "nav.services": "خدماتنا",
  "nav.talents": "المواهب",
  "nav.clients": "العملاء",
  "nav.content": "صناعة المحتوى",
  "nav.work": "أعمالنا",
  "nav.spotlight": "إضاءات",
  "nav.contact": "تواصل معنا",
  "nav.login": "تسجيل الدخول",
  "nav.dashboard": "لوحة تحكم",
  "nav.signOut": "تسجيل الخروج",
  "nav.notifications": "الإشعارات",
  "nav.profile": "ملفي الشخصي",
  "nav.castingCart": "سلة طلب الاختيار",
  "nav.clientDashboard": "لوحة تحكم العميل",
  "nav.talentDashboard": "لوحة تحكم الموهبة",
  "footer.description": "وكالة إبداعية متخصصة في الموديلينج، الكاستينج، وإنتاج الفيديوهات والمحتوى الإبداعي.",
  "footer.quickLinks.title": "روابط سريعة",
  "footer.links.about": "عن أرتيريا",
  "footer.links.services": "خدماتنا",
  "footer.links.talents": "المواهب",
  "footer.links.work": "أعمالنا",
  "footer.links.spotlight": "إضاءات",
  "footer.contact.title": "تواصل معنا",
  "footer.social.title": "تابعنا",
  "footer.social.comingSoon": "{{label}} — قريباً",
  "footer.copyright": "© {{year}} أرتيريا. جميع الحقوق محفوظة.",
  "footer.backToTop": "العودة للأعلى",

  // ── Common ───────────────────────────────────────────────────────────────────
  "common.signingOut": "جارٍ الخروج…",

  // ── Notifications ────────────────────────────────────────────────────────────
  "notifications.title": "الإشعارات",
  "notifications.empty": "لا توجد إشعارات جديدة",
  "notifications.noNotificationsYet": "لا توجد إشعارات بعد",
  "notifications.unreadCount": "{{count}} غير مقروءة",
  "notifications.newCount": "{{count}} جديدة",
  "notifications.markAllRead": "تعليم الكل كمقروء",
  "notifications.viewAll": "عرض كل الإشعارات ←",
  "notifications.newToast": "إشعار جديد",

  // ── Auth ─────────────────────────────────────────────────────────────────────
  "auth.login": "تسجيل الدخول",
  "auth.signup": "انضم إلينا",
  "auth.noAccount": "ليس لديك حساب؟",
  "auth.register": "سجل الآن",
  "auth.email": "البريد الإلكتروني",
  "auth.password": "كلمة المرور",
  "auth.firstName": "الاسم الأول",
  "auth.lastName": "الاسم الأخير",
  "auth.welcomeBack": "مرحباً بعودتك",
  "auth.signIn": "سجل دخولك لعالم أرتيريا",
  "auth.worldTagline": "عالم الإبداع، والحكايات، والتعبير الأصيل",
  "auth.toArteriaWorld": "إلى عالم أرتيريا",
  "auth.backToHome": "العودة للرئيسية",
  "auth.login.passwordPlaceholder": "أدخل كلمة المرور",

  // ── Auth: shared register fields ──────────────────────────────────────────
  "auth.alreadyHaveAccount": "هل لديك حساب بالفعل؟",
  "auth.signInLink": "تسجيل الدخول",
  "auth.back": "رجوع",
  "auth.joinArteria": "انضم إلى ARTERIA",
  "auth.emailAddress": "البريد الإلكتروني",
  "auth.emailPlaceholder": "your.email@example.com",
  "auth.emailAlreadyRegistered": "هذا البريد الإلكتروني مسجل بالفعل.",
  "auth.checkingEmail": "جارٍ التحقق من البريد الإلكتروني…",
  "auth.firstNamePlaceholder": "الاسم الأول",
  "auth.lastNamePlaceholder": "اسم العائلة",
  "auth.confirmPassword": "تأكيد كلمة المرور",
  "auth.passwordPlaceholder": "أنشئ كلمة مرور قوية",
  "auth.confirmPasswordPlaceholder": "أكد كلمة المرور",
  "auth.phoneNumber": "رقم الهاتف",
  "auth.whatsappNumber": "رقم الواتساب",

  // ── Auth: Register Role Select ─────────────────────────────────────────────
  "auth.registerRoleSelect.title": "انضم إلى ARTERIA",
  "auth.registerRoleSelect.step": "الخطوة 1 من 1",
  "auth.registerRoleSelect.talentTitle": "التسجيل كموهبة",
  "auth.registerRoleSelect.talentDescription": "اعرض مهاراتك واحصل على فرص عمل.",
  "auth.registerRoleSelect.clientTitle": "التسجيل كعميل",
  "auth.registerRoleSelect.clientDescription": "ابحث عن أفضل المواهب الإبداعية ووظّفها.",

  // ── Auth: Register Client ──────────────────────────────────────────────────
  "auth.registerClient.companyName": "اسم الشركة",
  "auth.registerClient.companyNamePlaceholder": "اسم شركتك",
  "auth.registerClient.companyType": "نوع الشركة",
  "auth.registerClient.companyTypePlaceholder": "مثال: وكالة، علامة تجارية، شركة إنتاج",
  "auth.registerClient.yourTitle": "مسماك الوظيفي",
  "auth.registerClient.titlePlaceholder": "مثال: مدير تنفيذي، مدير تسويق",
  "auth.registerClient.creatingAccount": "جارٍ إنشاء الحساب...",
  "auth.registerClient.createAccount": "إنشاء حساب عميل",

  // ── Auth: Register Talent (steps) ──────────────────────────────────────────
  "auth.registerTalent.stepBasicInfo": "المعلومات الأساسية",
  "auth.registerTalent.stepTalentDetails": "تفاصيل الموهبة",
  "auth.registerTalent.stepGallery": "المعرض",

  // ── Auth: Basic Info Step ──────────────────────────────────────────────────
  "auth.basicInfoStep.title": "المعلومات الأساسية",
  "auth.basicInfoStep.subtitle": "أخبرنا من أنت",
  "auth.basicInfoStep.continueButton": "المتابعة إلى تفاصيل الملف الشخصي",

  // ── Auth: Specialization Step ──────────────────────────────────────────────
  "auth.specializationStep.title": "تفاصيل ملفك الشخصي",
  "auth.specializationStep.subtitle": "اختر أنواع صناعة المحتوى الخاصة بك",
  "auth.specializationStep.contentCreatorTypes": "أنواع صناعة المحتوى",
  "auth.specializationStep.loadingTypes": "جارٍ تحميل أنواع المحتوى...",
  "auth.specializationStep.noTypesAvailable": "لا توجد أنواع محتوى متاحة",
  "auth.specializationStep.creating": "جارٍ الإنشاء…",
  "auth.specializationStep.createAccount": "إنشاء الحساب",

  // ── Auth: Register Content Creator ────────────────────────────────────────
  "auth.registerContentCreator.stepSpecializations": "التخصصات",
  "auth.registerContentCreator.title": "انضم كصانع محتوى",
  "auth.registerContentCreator.firstNamePlaceholder": "أدخل اسمك الأول",
  "auth.registerContentCreator.lastNamePlaceholder": "أدخل اسم العائلة",
  "auth.dateOfBirth": "تاريخ الميلاد",
  "auth.registerContentCreator.validating": "جارٍ التحقق...",
  "auth.registerContentCreator.continueToSpecializations": "المتابعة إلى التخصصات",

  // ── Auth: Interest Step ────────────────────────────────────────────────────
  "auth.interestStep.title": "ما الذي يثير اهتمامك؟",
  "auth.interestStep.subtitle": "اختر خيارًا واحدًا للمتابعة",
  "auth.interestStep.selectAtLeastOne": "يرجى اختيار اهتمام واحد على الأقل للمتابعة",
  "auth.interestStep.continueButton": "المتابعة إلى التسجيل",
  "auth.interestStep.modelingDescription": "أزياء، إعلانات، تحريرية، عروض أزياء",
  "auth.interestStep.contentCreationDescription": "محتوى المستخدمين، وسائل التواصل، محتوى رقمي",
  "auth.interestStep.bothDescription": "أنا مهتم بكل من عرض الأزياء وصناعة المحتوى",

  // ── Auth: Password Field ───────────────────────────────────────────────────
  "auth.passwordField.showPassword": "إظهار كلمة المرور",
  "auth.passwordField.hidePassword": "إخفاء كلمة المرور",

  // ── Auth: Questions Section ────────────────────────────────────────────────
  "auth.questionsSection.loading": "جارٍ تحميل الأسئلة...",
  "auth.questionsSection.title": "أسئلة إضافية",
  "auth.questionsSection.allRequired": "(الكل مطلوب)",
  "auth.questionsSection.answerAllToContinue": "يرجى الإجابة على جميع الأسئلة للمتابعة",

  // ── Auth: Talent Details Step ──────────────────────────────────────────────
  "auth.talentDetailsStep.title": "أكمل ملفك الشخصي كموهبة",
  "auth.talentDetailsStep.subtitle": "أخبرنا المزيد عن نفسك للحصول على فرص أفضل",
  "auth.talentDetailsStep.fixHighlighted": "يرجى تصحيح الحقول المظللة قبل المتابعة:",
  "auth.talentDetailsStep.answerAllQuestions": "يرجى الإجابة على جميع الأسئلة المطلوبة",
  "auth.talentDetailsStep.dateOfBirth": "تاريخ الميلاد *",
  "auth.talentDetailsStep.city": "المدينة",
  "auth.talentDetailsStep.cityPlaceholder": "مدينتك",
  "auth.talentDetailsStep.age": "العمر",
  "auth.talentDetailsStep.ageYears": "{{age}} سنة",
  "auth.talentDetailsStep.ageCalculatedAutomatically": "يُحسب تلقائيًا",
  "auth.talentDetailsStep.ageCategory": "الفئة العمرية:",
  "auth.talentDetailsStep.specialties": "التخصصات *",
  "auth.talentDetailsStep.specialization": "التخصص",
  "auth.talentDetailsStep.talentCategories": "فئات الموهبة",
  "auth.talentDetailsStep.gender": "الجنس *",
  "auth.talentDetailsStep.skinTone": "لون البشرة",
  "auth.talentDetailsStep.hairType": "نوع الشعر",
  "auth.talentDetailsStep.eyeColor": "لون العينين",
  "auth.talentDetailsStep.hairColor": "لون الشعر",
  "auth.talentDetailsStep.bodyType": "نوع الجسم",
  "auth.talentDetailsStep.lookAlike": "الشبيه",
  "auth.talentDetailsStep.experienceLevel": "مستوى الخبرة *",
  "auth.talentDetailsStep.bio": "الأعمال السابقة / نبذة",
  "auth.talentDetailsStep.bioPlaceholder": "أخبرنا عن نفسك...",
  "auth.talentDetailsStep.socialMediaProfiles": "حسابات التواصل الاجتماعي",
  "auth.talentDetailsStep.physicalDetails": "التفاصيل الجسدية",
  "auth.talentDetailsStep.heightCm": "الطول (سم)",
  "auth.talentDetailsStep.weightKg": "الوزن (كجم)",
  "auth.talentDetailsStep.tshirt": "التيشيرت",
  "auth.talentDetailsStep.pant": "البنطال",
  "auth.talentDetailsStep.shoe": "الحذاء",
  "auth.talentDetailsStep.ratesPricing": "الأسعار والتسعير",
  "auth.talentDetailsStep.ratesOptional": "الأسعار (اختياري)",
  "auth.talentDetailsStep.ratesPlaceholder": "جنيه مصري لكل 12 ساعة",
  "auth.talentDetailsStep.continueToGallery": "المتابعة إلى المعرض",

  // ── Auth: Gallery Upload Step ──────────────────────────────────────────────
  "auth.galleryUploadStep.title": "الملف الشخصي والمعرض",
  "auth.galleryUploadStep.subtitlePrefix": "قم برفع صورة شخصية",
  "auth.galleryUploadStep.required": "(مطلوب)",
  "auth.galleryUploadStep.subtitleSuffix": "وست صور على الأقل للمعرض",
  "auth.galleryUploadStep.profilePhoto": "صورة الملف الشخصي",
  "auth.galleryUploadStep.changePhoto": "تغيير الصورة",
  "auth.galleryUploadStep.uploadPhoto": "رفع صورة",
  "auth.galleryUploadStep.profilePhotoRequired": "صورة الملف الشخصي مطلوبة",
  "auth.galleryUploadStep.galleryPhotos": "صور المعرض",
  "auth.galleryUploadStep.dragDropHere": "اسحب وأفلت الصور هنا، أو",
  "auth.galleryUploadStep.browseFiles": "تصفح الملفات",
  "auth.galleryUploadStep.formatsHint": "JPG، PNG، WEBP · بحد أقصى {{maxMb}} ميجابايت لكل صورة",
  "auth.galleryUploadStep.slotsLeft": "{{count}} أماكن متبقية",
  "auth.galleryUploadStep.slotsLeftOne": "مكان واحد متبقٍ",
  "auth.galleryUploadStep.morePhotosNeeded": "يلزم {{count}} صور إضافية للمتابعة",
  "auth.galleryUploadStep.morePhotosNeededOne": "تلزم صورة واحدة إضافية للمتابعة",
  "auth.galleryUploadStep.submitting": "جارٍ الإرسال...",
  "auth.galleryUploadStep.completeRegistration": "إتمام التسجيل",
  "auth.galleryUploadStep.cropProfilePhoto": "قص صورة الملف الشخصي",

  // ── Auth: Validation Messages ──────────────────────────────────────────────
  "auth.validation.emailRequired": "البريد الإلكتروني مطلوب",
  "auth.validation.emailInvalid": "البريد الإلكتروني غير صالح",
  "auth.validation.passwordRequired": "كلمة المرور مطلوبة",
  "auth.validation.loginPasswordMin": "يجب ألا تقل كلمة المرور عن 6 أحرف",
  "auth.validation.firstNameRequired": "الاسم الأول مطلوب",
  "auth.validation.firstNameMin": "يجب ألا يقل الاسم الأول عن حرفين",
  "auth.validation.firstNameMax": "يجب ألا يتجاوز الاسم الأول 50 حرفًا",
  "auth.validation.firstNamePattern": "يمكن أن يحتوي الاسم الأول على حروف ومسافات وشرطات وفواصل علوية فقط",
  "auth.validation.lastNameRequired": "اسم العائلة مطلوب",
  "auth.validation.lastNameMin": "يجب ألا يقل اسم العائلة عن حرفين",
  "auth.validation.lastNameMax": "يجب ألا يتجاوز اسم العائلة 50 حرفًا",
  "auth.validation.lastNamePattern": "يمكن أن يحتوي اسم العائلة على حروف ومسافات وشرطات وفواصل علوية فقط",
  "auth.validation.phoneRequired": "رقم الهاتف مطلوب",
  "auth.validation.phoneInvalid": "أدخل رقم هاتف صالحًا للدولة المحددة",
  "auth.validation.countryRequired": "الدولة مطلوبة",
  "auth.validation.whatsappInvalid": "أدخل رقم واتساب صالحًا",
  "auth.validation.passwordMin8": "يجب ألا تقل كلمة المرور عن 8 أحرف",
  "auth.validation.passwordComplexity": "يجب أن تحتوي كلمة المرور على حرف كبير وحرف صغير ورقم ورمز خاص",
  "auth.validation.confirmPasswordRequired": "يرجى تأكيد كلمة المرور",
  "auth.validation.passwordsMismatch": "كلمتا المرور غير متطابقتين",
  "auth.validation.currentPasswordRequired": "كلمة المرور الحالية مطلوبة",
  "auth.validation.newPasswordRequired": "كلمة المرور الجديدة مطلوبة",
  "auth.validation.confirmNewPasswordRequired": "يرجى تأكيد كلمة المرور الجديدة",
  "auth.validation.newPasswordSameAsCurrent": "يجب أن تختلف كلمة المرور الجديدة عن كلمة المرور الحالية",
  "auth.validation.min2Chars": "حرفان على الأقل",
  "auth.validation.max50Chars": "50 حرفًا كحد أقصى",
  "auth.validation.lettersOnly": "حروف فقط",
  "auth.validation.dobRequired": "تاريخ الميلاد مطلوب",
  "auth.validation.invalidDate": "تاريخ غير صالح",
  "auth.validation.dobFuture": "لا يمكن أن يكون التاريخ في المستقبل",
  "auth.validation.dobInvalid": "يرجى إدخال تاريخ ميلاد صالح",
  "auth.validation.nationalityRequired": "الجنسية مطلوبة",
  "auth.validation.max1000Chars": "1000 حرف كحد أقصى",
  "auth.validation.experienceRequired": "مستوى الخبرة مطلوب",
  "auth.validation.genderRequired": "يرجى اختيار الجنس",
  "auth.validation.specialtyRequired": "اختر تخصصًا واحدًا على الأقل",
  "auth.validation.languageRequired": "اختر لغة واحدة على الأقل",
  "auth.validation.customLanguageRequired": "يرجى تحديد لغتك الأخرى",
  "auth.validation.heightPositive": "يجب أن يكون الطول رقمًا موجبًا",
  "auth.validation.weightPositive": "يجب أن يكون الوزن رقمًا موجبًا",
  "auth.validation.genderMale": "ذكر",
  "auth.validation.genderFemale": "أنثى",
  "auth.validation.ageCategoryInfants": "رضّع (0-2)",
  "auth.validation.ageCategoryToddler": "أطفال صغار (3-5)",
  "auth.validation.ageCategoryKids": "أطفال (6-11)",
  "auth.validation.ageCategoryTeens": "مراهقون (12-16)",
  "auth.validation.ageCategoryAdults": "شباب (17-25)",
  "auth.validation.ageCategoryPrime": "بالغون (26-35)",
  "auth.validation.ageCategoryMature": "متوسطو العمر (36-50)",
  "auth.validation.ageCategoryClassic": "كبار السن (+50)",
  "auth.validation.loginFailed": "فشل تسجيل الدخول. يرجى التحقق من بياناتك.",
  "auth.validation.accountCreatedRedirect": "تم إنشاء الحساب بنجاح! يرجى تسجيل الدخول.",
  "auth.validation.createAccountFailed": "فشل إنشاء الحساب.",
  "auth.validation.answerAllQuestions": "يرجى الإجابة على جميع الأسئلة قبل المتابعة.",
  "auth.validation.uploadProfilePhotoRequired": "يرجى رفع صورة شخصية قبل الإرسال.",
  "auth.validation.registrationFailed": "فشل إكمال التسجيل.",
  "auth.validation.selectContentCreatorType": "اختر نوعًا واحدًا على الأقل من أنواع صناعة المحتوى.",
  "auth.validation.uploadProfilePhoto": "يرجى رفع صورة شخصية.",
  "auth.validation.accountCreatedTitle": "تم إنشاء الحساب!",
  "auth.validation.registrationFailedGeneric": "فشل التسجيل.",
  "auth.galleryUploadStep.cropGalleryPhoto": "قص صورة المعرض",
  "auth.galleryUploadStep.cropGalleryPhotoWithMore": "قص صورة المعرض ({{count}} أخرى بعدها)",
  "auth.galleryUploadStep.unsupportedFormat": "{{name}}: صيغة غير مدعومة",
  "auth.galleryUploadStep.exceedsSize": "{{name}}: يتجاوز {{maxMb}} ميجابايت",

'or_contact_us_directly': 'أو تواصل معنا مباشرة',
  // ── Hero ─────────────────────────────────────────────────────────────────────
  "hero.slogan": "أرتيريا موطن المبدعين",
  "hero.tagline": "أرتيريا هي الثورة الجديدة في الكاستينج، وإدارة المواهب، وإنتاج المحتوى.",
  "hero.taglineEmphasized": "كن جزءاً من عالم أرتيريا",
  "hero.becomeTalent": "كن نجماً معنا",
  "hero.sendBrief": "نفذ مشروعك مع مواهبنا",
  "hero.scrollToExplore": "اسحب للاستكشاف",

  // ── About ─────────────────────────────────────────────────────────────────────
  "about.title": "عن أرتيريا",
  "about.description": "أرتيريا هي ثورة جديدة في عالم الكاستينج، إدارة المواهب، وصناعة المحتوى الإبداعي.",
  "about.mainTitle": "حيث يلتقي الفن بالابتكار",
  "about.mainDescription": "نبحث عن الوجوه التي تحكي قصص، والأصوات التي تُلهم، ونخلق محتوى ينبض بالحياة.",
  "about.secondaryDescription": "من خلال رؤية فنية مؤثرة، بنشكل حلقة وصل بين المواهب والحكايات اللي هتترك أثرها في الذاكرة.",
  "about.approach": "هنا... يعيش الإبداع، تتنفس الحكايات، وتكتشف المواهب حقيقتها الأعمق.",
  "about.tagline": "نحوّل المواهب الخام إلى قصص لا تُنسى",
  "about.stats.talents": "+1500 موهبة",
  "about.stats.projects": "+600 مشروع",
  "about.stats.satisfaction": "100% رضا عملائنا",
  "about.stats.talentsNetwork": "المواهب في شبكتنا",
  "about.stats.successfulProjects": "مشروعاً ناجحاً تم تنفيذه",
  "about.card.defaultSubtitle": "حيث يعيش الإبداع، تتنفس الحكايات، وتجد المواهب شكلها الأصدق",
  "about.imageAlt": "عن أرتيريا",
  "about.learnMore": "اعرف أكثر",
  "about.team.title": "تعرف على فريقنا",
  "about.team.description": "الأشخاص الشغوفون وراء رؤية أرتيريا",
  "about.team.member1.name": "محمد أشرف",
  "about.team.member1.role": "المؤسس والمدير الإبداعي",
  "about.team.member1.bio": "رائد أعمال صاحب رؤية وشغف بالفنون والتكنولوجيا. يمتلك محمد خبرة تزيد عن عشر سنوات في التوجيه الإبداعي وإدارة المواهب.",
  "about.team.member2.name": "محمد شاكر",
  "about.team.member2.role": "المدير التقني",
  "about.team.member2.bio": "مبتكر تقني وخبير في الهندسة الرقمية. يقود محمد مبادراتنا التقنية ويضمن تجارب رقمية سلسة لمجتمعنا.",
  "about.team.member3.name": "أيمن نور",
  "about.team.member3.role": "رئيس الاستراتيجية الإبداعية",
  "about.team.member3.bio": "مفكر إبداعي استراتيجي بعين مبتكرة. يشكل أيمن توجهنا الإبداعي ويجلب وجهات نظر جديدة لتطوير المواهب.",
  "about.story.title": "قصتنا",
  "about.story.content": "وُلِدت أرتيريا في عام 2022 من حلم بسيط — إننا نسلّط النور على المواهب اللي محدش شايفها.",
  "about.story.description": "لما توقفت المؤسسات التعليمية عن رعاية الفنون، تدخّلنا، مانحين المبدعين الشباب فرصة للتعلّم والنمو والظهور.",
  "about.story.approach": "رفضنا الانصياع لموجة المحتوى المُقلد. واخترنا القصص الحقيقية المتجذرة في الثقافة وروح الشارع.",
  "about.story.evolution": "أصبحت أرتيريا أكثر من مجرد كاستينج — تحوّلت إلى موطن إبداعي تلتقي فيه المواهب وتتعلّم من خلال قصص مؤمنين بيها.",
  "about.vision": "الرؤية",
  "about.vision.content": "أن نصبح القلب النابض للموهبة الأصيلة والسرد القصصي في مصر، حيث يرتقي الفن والثقافة والإبداع معاً.",
  "about.mission": "الرسالة",
  "about.mission.content": "اكتشاف، ورعاية، وعرض المواهب عبر كاستينج ومحتوى يتحدث لغة الشارع، الروح، والفن.",
  "about.values.title": "قيمنا الأساسية",
  "about.values.subtitle": "المبادئ التي توجه كل عمل نقوم به في أرتيريا",
  "about.values.ethics": "الأخلاقيات",
  "about.values.ethics.description": "نُبدع بأمانة، واحترام، ومسؤولية، محافظين دائماً على صدق مبادئنا.",
  "about.values.creativity": "الإبداع",
  "about.values.creativity.description": "نحوّل الأفكار الجريئة إلى مشاهد بصرية قوية تحرّك المشاعر وتُلهم.",
  "about.values.culture": "الثقافة",
  "about.values.culture.description": "نحتفي بجذورنا، عاكسين قصص شوارعنا، وتراثنا، وروحنا الفنية.",
  "about.values.collaboration": "التعاون",
  "about.values.collaboration.description": "نرتقي معاً من خلال التعلّم، والمشاركة، والدعم المتبادل.",
  "about.values.integrity": "النزاهة",
  "about.values.integrity.description": "نتمسك بما نؤمن به ونُمثّل فقط ما يتسم بالصدق والحقيقة.",
  "about.values.authenticity": "الأصالة",
  "about.values.authenticity.description": "نحتضن التعبير الصادق ونحتفي بالتفرد المميز في كل موهبة ومشروع.",

  // ── Services ──────────────────────────────────────────────────────────────────
  "services.title": "خدماتنا",
  "services.subtitle": "نحول أفكاركم إلى واقع",
  "services.mainDescription": "حلول شاملة لكافة احتياجاتكم من المواهب والمحتوى",
  "services.casting.section.title": "وكالة الكاستينج",
  "services.casting.section.description": "وكالة الكاستينج لدينا متخصصة في تحديد وتأمين المواهب المتنوعة لكافة المشاريع والإعلانات التجارية والأفلام والمحتوى الرقمي.",
  "services.casting.section.cta": "أرسل طلب كاستينج",
  "services.casting.section.features": [
    "قاعدة بيانات مواهب ثرية تضم أكثر من 1500 موديل مُعتمد",
    "مطابقة مثالية للمشروع باستخدام خوارزميات متقدمة",
    "فرز واختيار احترافي مع التحقق من الخلفيات",
    "سرعة قياسية في الإنجاز خلال 24-48 ساعة",
    "ترشيحات مواهب مُخصصة حسب الطلب",
    "مرونة في الحجز والجداول الزمنية",
  ],
  "services.content.section.title": "إنتاج المحتوى",
  "services.content.section.description": "نصنع مشاهد بصرية عالية الجودة ومؤثرة لكل منصة وهدف.",
  "services.content.section.cta": "اطلب عرض سعر",
  "services.content.section.features": [
    "إنتاج الأفلام الروائية والوثائقية",
    "حملات العلامات التجارية والمحتوى التجاري",
    "صناعة محتوى خاص لمنصات التواصل الاجتماعي",
    "صناعة الأفلام الوثائقية",
    "خدمة إنتاج متكاملة من الفكرة إلى التسليم النهائي",
    "خدمات ما بعد الإنتاج والمونتاج",
  ],
  "services.process.section.title": "آلية عملنا",
  "services.process.section.subtitle": "من الفكرة إلى التسليم، نضمن أن يتجاوز كل مشروع التوقعات",
  "services.process.section.steps": [
    { step: "01", title: "اكتشاف وتخطيط", description: "نتفهّم رؤيتكم وأهدافكم ومتطلباتكم لصياغة الاستراتيجية المثالية" },
    { step: "02", title: "اختيار المواهب والإنتاج", description: "يختار فريقنا بعناية الموهبة المناسبة ويبدأ عملية الإنتاج الإبداعي" },
    { step: "03", title: "التسليم والدعم", description: "نقدم نتائج استثنائية ونوفر الدعم المستمر لضمان نجاحكم" },
  ],
  "services.main.cta.title": "هل أنت مستعد لبدء مشروعك؟",
  "services.main.cta.subtitle": "دعنا نحيي رؤيتك بخدماتنا المتخصصة في المواهب والإنتاج",
  "services.main.cta.casting": "أرسل طلب كاستينج",
  "services.main.cta.content": "اطلب عرض سعر للمحتوى",
  "services.content.title": "إنتاج المحتوى",
  "services.content.description": "نصنع مشاهد بصرية عالية الجودة ومؤثرة لكل منصة وهدف.",
  "services.content.features.films": "إنتاج الأفلام الروائية والوثائقية",
  "services.content.features.campaigns": "حملات العلامات التجارية والمحتوى التجاري",
  "services.content.features.social": "صناعة محتوى خاص لمنصات التواصل الاجتماعي",
  "services.content.features.documentary": "صناعة الأفلام الوثائقية",
  "services.content.features.production": "خدمة إنتاج متكاملة من الفكرة إلى التسليم النهائي",
  "services.content.features.postproduction": "خدمات ما بعد الإنتاج والمونتاج",
  "services.content.cta": "اطلب عرض سعر",
  "services.process.title": "آلية عملنا",
  "services.process.subtitle": "من الفكرة إلى التسليم، نضمن أن يتجاوز كل مشروع التوقعات",
  "services.process.step1.title": "اكتشاف وتخطيط",
  "services.process.step1.description": "نتفهّم رؤيتكم وأهدافكم ومتطلباتكم لصياغة الاستراتيجية المثالية.",
  "services.process.step2.title": "اختيار المواهب والإنتاج",
  "services.process.step2.description": "يختار فريقنا بعناية الموهبة المناسبة ويبدأ عملية الإنتاج الإبداعي.",
  "services.process.step3.title": "التسليم والدعم",
  "services.process.step3.description": "نقدم نتائج استثنائية ونوفر الدعم المستمر لضمان نجاحكم.",
  "services.cta.title": "هل أنت مستعد لبدء مشروعك؟",
  "services.cta.subtitle": "دعنا نحيي رؤيتك بخدماتنا المتخصصة في المواهب والإنتاج",
  "services.cta.casting": "أرسل طلب كاستينج",
  "services.cta.content": "اطلب عرض سعر للمحتوى",

  // ── Talents ───────────────────────────────────────────────────────────────────
  "talents.title": "تبحث عن موهبة؟",
  "talents.subtitle": "اكتشف مواهبنا",
  "talents.description": "للمخرجين، المنتجين، المصورين، والمبدعين: سهّلنا عملية الكاستينج بالكامل.",
  "talents.library": "اكتشف مكتبتنا للمواهب من موديلز ومبدعين موثّقين، وابحث حسب السن والشكل والمهارة كل ده في مكان واحد.",
  "talents.library.title": "اكتشف جميع مواهبنا",
  "talents.library.description": "اكتشف نجومنا من خلال مكتبة متنوعة فيها كل اللي محتاجه لمشروعك.",
  "talents.features.nodelay": "سرعة في التسليم",
  "talents.features.instant": "وصول فوري للمواهب الموثّقة",
  "talents.features.nobackforth": "عملية مبسّطة",
  "talents.features.streamlined": "عملية اختيار سلسة",
  "talents.features.righttalent": "الموهبة المناسبة",
  "talents.features.perfectmatch": "اختيار مثالي في كل مرة",
  "talents.projects": "سواء بتشتغل على فيلم، مسلسل، إعلان، UGC، أو محتوى رقمي أرتيريا جاهزة لك.",
  "talents.steps.title": "إزاي الشغل بيتم؟",
  "talents.steps.1.title": "ابعتلنا البريف",
  "talents.steps.1.description": "قولنا أكتر عن طبيعة مشروعك ورؤيتك واحتياجاتك",
  "talents.steps.2.title": "اختار من مكتبتنا",
  "talents.steps.2.description": "هتلاقي عندنا كل اللي محتاجه وابحث عنهم باستخدام فلاتر دقيقة",
  "talents.steps.3.title": "احصل على عرض سعر",
  "talents.steps.3.description": "في خلال أقل من 24 ساعة هنكون ردينا عليك بكل التفاصيل",
  "talents.cta.brief": "ابعتلنا بريف عن مشروعك",
  "talents.cta.subtitle": "استشارة مجانية • رد خلال ٢٤ ساعة • عروض أسعار مخصصة",
  "talents.mainCta": "اكتشف المواهب. وفّر وقتك. اصنع الأفضل.",
  "talents.filters": "الفلاتر",
  "talents.hero.badge": "مركز المواهب",
  "talents.hero.description": "اكتشف الوجوه التي تُحيي القصص. كل موهبة في شبكتنا مُختارة بعناية لحضورها المميز وتميّزها الاحترافي.",
  "talents.clearAll": "مسح الكل",
  "talents.foundOne": "موهبة",
  "talents.foundMany": "مواهب",
  "talents.noMatch.title": "لا توجد مواهب مطابقة لبحثك",
  "talents.noMatch.subtitle": "حاول تعديل الفلاتر أو مصطلح البحث",
  "talents.clearFilters": "مسح الفلاتر",
  "talents.loadingMore": "جارٍ تحميل المزيد من المواهب…",
  "talents.filters.talentType": "نوع الموهبة",
  "talents.filters.gender": "الجنس",
  "talents.filters.age": "العمر",
  "talents.filters.bodyType": "شكل الجسم",
  "talents.filters.experience": "الخبرة",
  "talents.filters.skinTone": "لون البشرة",
  "talents.filters.hairType": "نوع الشعر",
  "talents.filters.hairColor": "لون الشعر",
  "talents.filters.eyeColor": "لون العين",
  "talents.filters.weight": "الوزن",
  "talents.filters.height": "الطول",
  "talents.filters.languages": "اللغات",
  "talents.filters.lookAlike": "يشبه",
  "talents.filters.category": "الفئة",
  "talents.filters.clearAllFilters": "مسح كل الفلاتر",
  "talents.filters.searchPlaceholder": "ابحث عن المواهب...",
  "talents.filters.experience.beginner": "مبتدئ (٠-١ سنة)",
  "talents.filters.experience.intermediate": "متوسط (٢-٥ سنوات)",
  "talents.filters.experience.professional": "محترف (+٥ سنوات)",
  "talents.filters.experience.expert": "خبير (+١٠ سنوات)",
  "talents.view_all": "شاهد كل المواهب",
  "talents.showcase.badge": "نجومنا",
  "talents.showcase.titlePrefix": "تعرف على",
  "talents.showcase.subtitle": "اكتشف مواهب استثنائية من مجموعتنا المتنوعة من الموديلز والممثلين والمبدعين المحترفين",
  "talents.showcase.empty": "لا توجد مواهب",
  // ── Content ───────────────────────────────────────────────────────────────────
  "content.title": "نحوّل الأفكار",
  "content.pageTitle": "صناعة المحتوى",
  "content.titleHighlight": "إلى حكايات تتنفس",
  "content.description": "نصنع محتوى جريء تقوده الحكاية. من الوثائقيات إلى أفلام البراندات والريلز — كل كادر نخلقه له روح وله معنى.",
  "content.discover": "اكتشف أكثر",
  "content.project": "المشروع",
  "content.projectDescription": "سرد قصص العلامات التجارية بأسلوب يربط ويلهم",
  "content.types.documentaries.title": "الأفلام الوثائقية",
  "content.types.documentaries.desc": "سرد قصصي أصيل يلتقط اللحظات الحقيقية والمشاعر الصادقة بجودة سينمائية.",
  "content.types.fashion.title": "أفلام الأزياء",
  "content.types.fashion.desc": "سرديات بصرية أنيقة تعرض الأزياء والجمال بلمسة سينمائية.",
  "content.types.social.title": "محتوى وسائل التواصل الاجتماعي",
  "content.types.social.desc": "منشورات وقصص وريلز جذابة تلفت الانتباه وتعزز التفاعل عبر جميع المنصات.",
  "content.types.brand.title": "محتوى العلامة التجارية",
  "content.types.brand.desc": "قصص علامة تجارية مقنعة تتواصل مع الجمهور وتترك انطباعًا دائمًا.",
  "content.contentTypes": [
    { title: "المحتوى الاجتماعي", desc: "بوستات وستوريز وريلز جذابة تلفت الانتباه وتزيد التفاعل على جميع المنصات." },
    { title: "الأفلام الوثائقية", desc: "سرد قصصي أصيل يلتقط اللحظات الحقيقية والمشاعر الصادقة بجودة سينمائية." },
    { title: "الإعلانات التجارية", desc: "إعلانات مقنعة تتواصل مع الجمهور وتعزز الوعي بالعلامة التجارية." },
    { title: "محتوى UGC", desc: "محتوى بأسلوب المستخدمين يبدو أصيلاً وقريباً من الجماهير الحديثة." },
    { title: "أفلام الفعاليات والشركات", desc: "توثيق احترافي للفعاليات والمؤتمرات وتفعيلات العلامات التجارية." },
    { title: "السكتشات والترفيه", desc: "محتوى ترفيهي وإبداعي يجلب الفرحة ويبني المجتمع." },
    { title: "تصوير العلامات التجارية", desc: "أصول بصرية مذهلة تمثل علامتك التجارية بأسلوب وأصالة." },
  ],
  "content.process": [
    { step: "01", title: "اكتشاف الرؤية", description: "نتعمق في قصتك، ونفهم رؤيتك وجمهورك وأهدافك لنخلق الاستراتيجية السردية المثالية." },
    { step: "02", title: "التطوير الإبداعي", description: "يطور فريقنا المفاهيم والنصوص والمعالجات البصرية التي تجسّد قصتك بأصالة وتأثير." },
    { step: "03", title: "التميز في الإنتاج", description: "من الكاستينج إلى التصوير، ندير كل تفصيلة بدقة لضمان أعلى جودة في الإخراج." },
    { step: "04", title: "سحر ما بعد الإنتاج", description: "يصنع مُحررونا ومصمّمونا اللمسة الأخيرة التي تجعل محتواك لا يُنسى." },
  ],
  "content.hero.titleLine1": "نحكي قصصًا",
  "content.hero.titleLine2": "يستحقّ العالم أن يتذكّرها",
  "content.hero.description": "كل كادر، وكل صوت، وكل كلمة، مصنوعة لتُحرّك القلوب، وتُشعل الحوار، وتترك أثرًا. من ريلز مدته 15 ثانية إلى فيلم وثائقي طويل، نحوّل الأفكار إلى قصص تستحق أن تُروى.",
  "content.hero.cta": "احكيها معنا",
  "content.whatWeCreate.badge": "ماذا نصنع",
  "content.whatWeCreate.titlePrefix": "محتوى",
  "content.whatWeCreate.titleHighlight": "يتواصل",
  "content.whatWeCreate.subtitle": "من محتوى السوشيال ميديا إلى الأفلام الوثائقية الطويلة، نصنع قصصًا بصرية تتفاعل مع الجمهور وتحقق تفاعلاً حقيقياً.",
  "content.featured.titlePrefix": "أبرز",
  "content.featured.titleHighlight": "المحتوى",
  "content.featured.subtitle": "عرض لأكثر أعمالنا تأثيرًا عبر صيغ مختلفة",
  "content.noVideo": "لا يوجد فيديو",
  "content.metrics": "إعجابات: {{likes}} · مشاهدات: {{views}}",
  "content.process.titlePrefix": "عمليتنا",
  "content.process.titleHighlight": "الإبداعية",
  "content.process.subtitle": "من الفكرة الأولى إلى التسليم النهائي، نضمن أن يتجاوز كل مشروع التوقعات",
  "content.portfolioShowcase": [
    { title: "ثورة السوشيال ميديا", description: "حملة فيروسية أعادت تعريف كيفية تواصل العلامات التجارية مع الشباب المصري", category: "سوشيال ميديا", metrics: "2M+ مشاهدة، 150K تفاعل" },
    { title: "شوارع القاهرة", description: "سلسلة وثائقية تعرض القصص غير المروية لفناني الشارع المصري", category: "وثائقي", metrics: "سلسلة حائزة على جوائز" },
    { title: "تحويل العلامة التجارية", description: "إعادة هوية بصرية كاملة من خلال سرد قصصي أصيل ومواهب محلية", category: "تجاري", metrics: "300% زيادة في الوعي بالعلامة" },
    { title: "التراث الثقافي", description: "الحفاظ على التقاليد المصرية من خلال السرد البصري الحديث", category: "فيلم براند", metrics: "تقدير دولي" },
    { title: "أصوات الشباب", description: "تضخيم أصوات المبدعين المصريين الشباب وقصصهم", category: "UGC", metrics: "+500K وصول عضوي" },
    { title: "التميز المؤسسي", description: "تغطية احترافية للفعاليات تلتقط جوهر النجاح التجاري", category: "مؤسسي", metrics: "عملاء Fortune 500" },
  ],

  // ── Spotlight ─────────────────────────────────────────────────────────────────
  "spotlight.title": "سبوت لايت",
  "spotlight.subtitle": "القصص والمقالات",
  "spotlight.description": "كل قصة ترسم مشهداً، وكل صوت يبني عالماً. مرحباً بك في سبوت لايت أرتيريا",
  "spotlight.readMore": "اقرأ المزيد",
  "spotlight.page.blogs": "المدونات",
  "spotlight.searchPlaceholder": "ابحث في المدونات...",
  "spotlight.empty": "لا توجد مدونات.",
  "spotlight.viewAll": "شاهد كل مقالاتنا",
  "spotlight.categories.all": "الكل",
  "spotlight.categories.art": "الفن",
  "spotlight.categories.news": "الأخبار",
  "spotlight.categories.industry": "رؤى الصناعة",
  "spotlight.categories.casting": "الكاستينج",
  "spotlight.categories.company": "الشركة",
  "spotlight.categories.creative": "الإبداع",
  "spotlight.readTime": "دقيقة قراءة",
  "spotlight.author": "الكاتب",
  "spotlight.date": "التاريخ",
  "spotlight.category": "الفئة",
  "spotlight.blogs.1.title": "مستقبل السرد الأصيل في السينما المصرية",
  "spotlight.blogs.1.excerpt": "كيف تعيد أرتيريا تشكيل طريقة اختيار المواهب وإنتاج المحتوى الذي يمثل حقاً الثقافة المصرية.",
  "spotlight.blogs.1.date": "١٥ ديسمبر ٢٠٢٤",
  "spotlight.blogs.1.author": "فريق أرتيريا",
  "spotlight.blogs.2.title": "خلف الكواليس: البحث عن الأصالة",
  "spotlight.blogs.2.excerpt": "منهجنا في إيجاد الوجوه الحقيقية التي تروي قصصاً صادقة.",
  "spotlight.blogs.2.date": "١٠ ديسمبر ٢٠٢٤",
  "spotlight.blogs.2.author": "سارة أحمد",
  "spotlight.blogs.3.title": "من الشارع إلى الشاشة: رحلتنا",
  "spotlight.blogs.3.excerpt": "قصة كيف أصبحت أرتيريا موطناً للمواهب الخام غير المكتشفة.",
  "spotlight.blogs.3.date": "٨ ديسمبر ٢٠٢٤",
  "spotlight.blogs.3.author": "محمد حسن",
  "spotlight.blogs.4.title": "الإخراج الإبداعي في العصر الرقمي",
  "spotlight.blogs.4.excerpt": "مزج السرد التقليدي مع المنصات الرقمية الحديثة.",
  "spotlight.blogs.4.date": "٥ ديسمبر ٢٠٢٤",
  "spotlight.blogs.4.author": "ليلى منصور",

  // ── Work ─────────────────────────────────────────────────────────────────────
  "work.title": "أعمالنا وشهادات عملائنا",
  "work.description": "اكتشف القصص وراء نجاحنا: مشاريع حقيقية، تأثير فعلي، أصوات صادقة.",
  "work.cta": "شوف سابقة أعمالنا",
  "work.showcase.titlePrefix": "",
  "work.showcase.titleHighlight": "أعمالنا",
  "work.showcase.titleSuffix": "وشهادات عملائنا",
  "work.loadError.title": "تعذر تحميل الأعمال",
  "work.loadError.subtitle": "تحقق من اتصال الإنترنت وحاول مرة أخرى.",
  "work.empty": "لا توجد أعمال بعد.",
  "work.brands.title": "كل العلامات التجارية الكبيرة وثقت فينا",
  "work.brands.description": "تعاوننا مع أكبر العلامات التجارية في السوق علشان نخلق تجربة إنتاج محتوى مميزة تليق بأعمالها",
  "work.brands.subtitle": "تعاونّا مع كبرى العلامات التجارية لصنع محتوى أصيل ومؤثر",
  "work.testimonials.title": "شهادات العملاء",
  "work.testimonials.description": "تعرف على ما يقوله عملاؤنا عن تجربتهم معنا",
  "work.hero.badge": "أعمالنا",
  "work.featured.titlePrefix": "أبرز",
  "work.featured.titleHighlight": "المشاريع",
  "work.featured.subtitle": "عرض لأكثر أعمالنا تأثيرًا عبر مختلف القطاعات والمجالات الإبداعية",
  "work.ariaPlay": "تشغيل {{title}}",
  "work.ariaPlaying": "جارٍ تشغيل {{title}}",
  "work.closeVideo": "إغلاق الفيديو",
  "work.noVideoAvailable": "لا يوجد فيديو متاح",
  "work.testimonials.empty": "لا توجد شهادات بعد.",
  "work.testimonials.projectLabel": "المشروع:",
  "work.brands.empty": "لا توجد علامات تجارية لعرضها.",
  "albums.viewImageAlt": "عرض الصورة {{index}}",
  "albums.galleryImageAlt": "صورة المعرض {{index}}",
  "albums.previousImage": "الصورة السابقة",
  "albums.nextImage": "الصورة التالية",
  // ── Talent Profile ─────────────────────────────────────────────────────────────
  "talentProfile.backToTalents": "العودة إلى المواهب",
  "talentProfile.notFound": "لم يتم العثور على الموهبة",
  "talentProfile.label": "الملف الشخصي للموهبة",
  "talentProfile.defaultName": "موهبة",
  "talentProfile.noPhoto": "لا توجد صورة",
  "talentProfile.addedToBrief": "تمت الإضافة إلى الطلب",
  "talentProfile.castNow": "اختيار {{name}}",
  "talentProfile.thisTalent": "هذه الموهبة",
  "talentProfile.yrs": "سنة",
  "talentProfile.cm": "سم",
  "talentProfile.kg": "كجم",
  "talentProfile.yrsExp": "سنوات خبرة",
  "talentProfile.physical": "الصفات الجسدية",
  "talentProfile.skills": "المهارات",
  "talentProfile.languages": "اللغات",
  "talentProfile.portfolio": "الأعمال",
  "talentProfile.attrs.gender": "الجنس",
  "talentProfile.attrs.eyeColor": "لون العين",
  "talentProfile.attrs.hairColor": "لون الشعر",
  "talentProfile.attrs.hairType": "نوع الشعر",
  "talentProfile.attrs.skinTone": "لون البشرة",
  "talentProfile.attrs.bodyType": "شكل الجسم",
  "talentProfile.attrs.nationality": "الجنسية",
  "talentProfile.attrs.city": "المدينة",
  "talentProfile.attrs.shoeSize": "مقاس الحذاء",
  "talentProfile.attrs.pantSize": "مقاس البنطال",
  "talentCard.showProfile": "عرض الملف",
  "talentCard.like": "إعجاب",
  "talentCard.unlike": "إلغاء الإعجاب",
  "talentCard.added": "تمت الإضافة",
  "talentCard.hireNow": "توظيف الآن",
  "talentCard.castNow": "اختيار الآن",
  "talentCard.eyes": "العينان",
  "talentCard.hair": "الشعر",
  "talentCard.skin": "البشرة",
  "talentCard.country": "الدولة",
  "talentCard.lang": "اللغة",
  "gallery.title": "معرض الأعمال",
  "gallery.uploadPhotos": "رفع صور",
  "gallery.uploading": "جارٍ الرفع…",
  "gallery.all": "الكل",
  "gallery.photos": "الصور",
  "gallery.videos": "الفيديوهات",
  "gallery.empty": "لا توجد أعمال متاحة بعد",
  "gallery.emptySubtitle": "تفقد الصفحة قريبًا للاطلاع على التحديثات!",
  "gallery.imageAlt": "عمل من الأعمال",
  "blogs.title": "المقالات",
  "comments.title": "آراء العملاء",
  // ── Shared: Status labels ──────────────────────────────────────────────────
  "status.active": "نشط",
  "status.pending": "قيد الانتظار",
  "status.inReview": "قيد المراجعة",
  "status.approved": "تمت الموافقة",
  "status.rejected": "مرفوض",
  "status.completed": "مكتمل",
  "status.draft": "مسودة",
  "priority.urgent": "عاجل",
  "priority.high": "مرتفعة",
  "priority.medium": "متوسطة",
  "priority.low": "منخفضة",
  // ── Client Dashboard ──────────────────────────────────────────────────────────
  "clientDashboard.portalBadge": "بوابة العميل",
  "clientDashboard.title": "لوحة التحكم",
  "clientDashboard.welcomeBack": "مرحبًا بعودتك، {{name}}",
  "clientDashboard.writeBlog": "كتابة مقال",
  "clientDashboard.newCastingBrief": "طلب اختيار جديد",
  "clientDashboard.tabOverview": "نظرة عامة",
  "clientDashboard.tabMyBlogs": "مقالاتي",
  "clientDashboard.tabMyBriefs": "طلباتي",
  "clientDashboard.stats.totalBriefs": "إجمالي الطلبات",
  "clientDashboard.stats.pendingBriefs": "طلبات قيد الانتظار",
  "clientDashboard.stats.inReview": "قيد المراجعة",
  "clientDashboard.stats.completed": "مكتملة",
  "clientDashboard.stats.totalBlogs": "إجمالي المقالات",
  "clientDashboard.stats.publishedBlogs": "المقالات المنشورة",
  "clientDashboard.quickActions": "إجراءات سريعة",
  "clientDashboard.createBlogAction": "إنشاء مقال",
  "clientDashboard.myBlogsAction": "مقالاتي",
  "clientDashboard.myBriefsAction": "طلباتي",
  "clientDashboard.editProfileAction": "تعديل الملف الشخصي",
  "clientDashboard.recentBriefs": "أحدث الطلبات",
  "clientDashboard.viewAll": "عرض الكل ←",
  "clientDashboard.blogCountOne": "مقال واحد",
  "clientDashboard.blogCountOther": "{{count}} مقالات",
  "clientDashboard.briefCountOne": "طلب واحد",
  "clientDashboard.briefCountOther": "{{count}} طلبات",
  "clientDashboard.newBlog": "مقال جديد",
  "clientDashboard.noBlogsYet": "لا توجد مقالات بعد",
  "clientDashboard.createFirstBlog": "أنشئ مقالك الأول",
  "clientDashboard.newBrief": "طلب جديد",
  "clientDashboard.noBriefsYet": "لا توجد طلبات اختيار بعد",
  "clientDashboard.submitFirstBrief": "أرسل طلبك الأول",
  "clientDashboard.viewBriefTooltip": "عرض الطلب",
  "clientDashboard.tableProjectType": "نوع المشروع",
  "clientDashboard.tableTalents": "المواهب",
  "clientDashboard.tableSubmitted": "تاريخ الإرسال",
  "clientDashboard.loadBriefsError": "فشل تحميل الطلبات",
  "clientDashboard.loadDataError": "خطأ أثناء تحميل البيانات",
  "clientDashboard.getBriefFailed": "فشل تحميل الطلب",
  "clientDashboard.titleRequired": "العنوان مطلوب",
  "clientDashboard.contentRequired": "المحتوى مطلوب",
  "clientDashboard.categoryRequired": "التصنيف مطلوب",
  "clientDashboard.blogUpdatedMsg": "تم تحديث المقال! في انتظار مراجعة الإدارة.",
  "clientDashboard.blogSubmittedMsg": "تم إرسال المقال! في انتظار مراجعة الإدارة.",
  "clientDashboard.saveBlogFailed": "فشل حفظ المقال.",
  "clientDashboard.deleteBlogTitle": "حذف المقال؟",
  "clientBriefDetailsModal.title": "تفاصيل الطلب",
  "clientBriefDetailsModal.loading": "جارٍ تحميل الطلب…",
  "clientBriefDetailsModal.submittedOn": "أُرسل بتاريخ {{date}}",
  "clients.title": "العملاء",
  "clients.hero.badge": "مركز العملاء",
  "clients.hero.description": "تعرّف على العلامات التجارية والشركات التي تثق بشبكة مواهبنا لتحقيق رؤيتها الإبداعية.",
  "clients.searchPlaceholder": "ابحث عن العملاء...",
  "clients.foundOne": "عميل",
  "clients.foundMany": "عملاء",
  "clients.noMatch.title": "لا يوجد عملاء يطابقون بحثك",
  "clients.loadMore": "تحميل المزيد من العملاء",
  "submitBlog.badge": "إضاءات",
  "submitBlog.title": "أرسل مقالًا",
  "submitBlog.subtitle": "سيتم مراجعة مقالك من قبل فريقنا قبل النشر",
  "submitBlog.titleFieldLabel": "العنوان *",
  "submitBlog.titlePlaceholder": "عنوان مقالك",
  "submitBlog.introPlaceholder": "ملخص مختصر (اختياري)",
  "submitBlog.contentFieldLabel": "المحتوى *",
  "submitBlog.titleAndContentRequired": "العنوان والمحتوى مطلوبان",
  "submitBlog.submittedSuccess": "تم إرسال المقال للمراجعة!",
  "submitBlog.submitFailed": "فشل إرسال المقال",
  "submitBlog.submitButton": "إرسال للمراجعة",
  "castingBriefForm.badge": "طلب اختيار",
  "castingBriefForm.heroTitlePrefix": "أرسل",
  "castingBriefForm.heroSubtitle1": "فقط شارك التفاصيل، الأمر يستغرق أقل من 5 دقائق.",
  "castingBriefForm.heroSubtitle2": "أو اكتب رؤيتك الأكثر جرأة في الملاحظات وسنتولى الباقي!",
  "castingBriefForm.formTitle": "أخبرنا عن مشروعك",
  "castingBriefForm.formSubtitle": "املأ التفاصيل وسنوفّق لك أفضل المواهب",
  "castingBriefForm.draftRestored": "لقد استعدنا المسودة التي كنت تملؤها قبل تسجيل خروجك.",
  "castingBriefForm.firstNameLabel": "اسمك الأول *",
  "castingBriefForm.lastNameLabel": "اسم العائلة *",
  "castingBriefForm.emailLabel": "البريد الإلكتروني *",
  "castingBriefForm.phoneLabel": "رقم الهاتف *",
  "castingBriefForm.companyLabel": "الشركة",
  "castingBriefForm.companyNotSet": "غير محدد —",
  "castingBriefForm.addCompanyLink": "أضف شركتك إلى ملفك الشخصي",
  "castingBriefForm.projectTypeLabel": "نوع المشروع *",
  "castingBriefForm.loadingProjectTypes": "جارٍ تحميل أنواع المشاريع…",
  "castingBriefForm.selectProjectType": "اختر نوع المشروع",
  "castingBriefForm.projectTypesError": "تعذّر تحميل أنواع المشاريع — لن تتمكن من الإرسال حتى يتم إصلاح ذلك.",
  "castingBriefForm.projectDescriptionLabel": "وصف المشروع *",
  "castingBriefForm.projectDescriptionPlaceholder": "صف مشروعك، رؤيتك، وما تبحث عنه...",
  "castingBriefForm.locationLabel": "الموقع",
  "castingBriefForm.locationPlaceholder": "مثال: القاهرة، مصر",
  "castingBriefForm.shootDateLabel": "تاريخ التصوير",
  "castingBriefForm.budgetLabel": "نطاق الميزانية (جنيه مصري)",
  "castingBriefForm.specialtiesLabel": "تخصصات المواهب",
  "castingBriefForm.loadingSpecialties": "جارٍ تحميل التخصصات…",
  "castingBriefForm.specialtiesError": "تعذّر تحميل التخصصات.",
  "castingBriefForm.subOptions": "خيارات فرعية",
  "castingBriefForm.demographicsTitle": "الفئة الديموغرافية للموهبة",
  "castingBriefForm.cityLabel": "المدينة",
  "castingBriefForm.cityPlaceholder": "مثال: القاهرة",
  "castingBriefForm.physicalAttributesTitle": "الصفات الجسدية",
  "castingBriefForm.heightRangeLabel": "نطاق الطول (سم)",
  "castingBriefForm.weightRangeLabel": "نطاق الوزن (كجم)",
  "castingBriefForm.talentTypeLabel": "نوع الموهبة",
  "castingBriefForm.experienceLevelLabel": "مستوى الخبرة",
  "castingBriefForm.anyLevel": "أي مستوى",
  "castingBriefForm.availableFromLabel": "متاح من",
  "castingBriefForm.availableToLabel": "متاح حتى",
  "castingBriefForm.recommendedTalentsLabel": "المواهب المقترحة",
  "castingBriefForm.loadingTalents": "جارٍ تحميل المواهب…",
  "castingBriefForm.recommendedError": "تعذّر تحميل المواهب المقترحة الآن — جرّب تعديل أحد الفلاتر أو أعد المحاولة لاحقًا.",
  "castingBriefForm.noMatchingTalents": "لا توجد مواهب مطابقة.",
  "castingBriefForm.addTalentAria": "إضافة {{name}} إلى طلبك",
  "castingBriefForm.thisTalent": "هذه الموهبة",
  "castingBriefForm.unnamedTalent": "بدون اسم",
  "castingBriefForm.selectedTalentsLabel": "المواهب المختارة ({{count}})",
  "castingBriefForm.removeTalentAria": "إزالة {{name}} من طلبك",
  "castingBriefForm.notesLabel": "ملاحظات إضافية",
  "castingBriefForm.notesPlaceholder": "أي تفاصيل إضافية، رؤية، متطلبات خاصة، أو توجيه إبداعي…",
  "castingBriefForm.submitting": "جارٍ الإرسال…",
  "castingBriefForm.submitButton": "إرسال طلب الاختيار",
  "castingBriefForm.submittedSuccess": "تم إرسال الطلب! جارٍ إعادة التوجيه…",
  "castingBriefForm.submitFailed": "فشل الإرسال. يرجى المحاولة مرة أخرى.",
  "castingBriefForm.responseTime": "سنعاود التواصل معك خلال 24 ساعة",
  "castingBriefForm.responseAvailability": "استجابة على مدار الساعة",
  "castingBriefForm.any": "أي",
  "castingBriefForm.min": "الحد الأدنى",
  "castingBriefForm.max": "الحد الأقصى",
  "contentCreatorTalentCard.years": "سنة",
  "contentCreatorTalentCard.added": "تمت الإضافة",
  "contentCreatorTalentCard.castNow": "اختيار الآن",
  "contentCreatorTalentCard.viewProfile": "عرض الملف الشخصي",
  "contentCreatorTalents.loadFailed": "فشل تحميل المواهب.",
  "contentCreatorTalents.profileLoadFailed": "فشل تحميل الموهبة",
  "contentCreatorProfile.updatePhotoFailed": "فشل تحديث الصورة",
  "contentCreatorProfile.notFound": "لم يتم العثور على الملف الشخصي.",
  "blogModal.tabDetails": "التفاصيل",
  "blogModal.tabContent": "المحتوى",
  "blogModal.tabMedia": "الوسائط والوسوم",
  "blogModal.editTitle": "تعديل المقال",
  "blogModal.createTitle": "إنشاء مقال",
  "blogModal.titleLabel": "العنوان",
  "blogModal.titlePlaceholder": "عنوان المقال",
  "blogModal.introLabel": "المقدمة",
  "blogModal.introPlaceholder": "وصف مختصر يظهر في القوائم",
  "blogModal.categoryLabel": "التصنيف",
  "blogModal.selectCategory": "اختر تصنيفًا",
  "blogModal.contentPlaceholder": "اكتب محتوى المقال هنا…",
  "blogModal.coverImageLabel": "صورة الغلاف",
  "blogModal.uploadCoverImage": "اضغط لرفع صورة الغلاف",
  "blogModal.tagsLabel": "الوسوم",
  "blogModal.tagPlaceholder": "أضف وسمًا، ثم اضغط Enter",
  "blogModal.back": "→ رجوع",
  "blogModal.next": "التالي ←",
  "blogModal.saving": "جارٍ الحفظ…",
  "blogModal.submitting": "جارٍ الإرسال…",
  "blogModal.saveChanges": "حفظ التغييرات",
  "blogModal.submitBlog": "إرسال المقال",
  // ── Profile (shared page) ─────────────────────────────────────────────────────
  "profile.roleAdmin": "مدير",
  "profile.roleClient": "عميل",
  "profile.roleTalent": "موهبة",
  "profile.defaultName": "مستخدم",
  "profile.uploadImageTooltip": "رفع صورة",
  "profile.removeImageTooltip": "إزالة الصورة",
  "profile.confirmDeleteImage": "هل أنت متأكد من رغبتك في إزالة صورة ملفك الشخصي؟",
  "profile.invalidImageType": "يرجى رفع صورة صالحة (JPEG أو PNG أو WebP)",
  "profile.imageTooLarge": "يجب ألا يتجاوز حجم الصورة 5 ميغابايت",
  "profile.uploadFailed": "فشل رفع الصورة",
  "profile.deleteFailed": "فشل حذف الصورة",
  "profile.loadFailed": "فشل تحميل الملف الشخصي.",
  "profile.previewTitle": "معاينة صورة الملف الشخصي",
  "profile.uploading": "جارٍ الرفع...",
  "changePassword.title": "تغيير كلمة المرور",
  "changePassword.currentPassword": "كلمة المرور الحالية",
  "changePassword.newPassword": "كلمة المرور الجديدة",
  "changePassword.confirmNewPassword": "تأكيد كلمة المرور الجديدة",
  "changePassword.updating": "جارٍ التحديث...",
  "changePassword.updateButton": "تحديث كلمة المرور",
  "changePassword.successToast": "تم تغيير كلمة المرور بنجاح",
  "changePassword.failToast": "فشل تغيير كلمة المرور",
  "clientProfileForm.personalInfo": "المعلومات الشخصية",
  "clientProfileForm.firstName": "الاسم الأول",
  "clientProfileForm.lastName": "اسم العائلة",
  "clientProfileForm.email": "البريد الإلكتروني",
  "clientProfileForm.title": "المسمى الوظيفي",
  "clientProfileForm.companyInfo": "معلومات الشركة",
  "clientProfileForm.companyName": "اسم الشركة",
  "clientProfileForm.saveChanges": "حفظ التغييرات",
  "clientProfilePage.titlePlaceholder": "المسمى الوظيفي (مدير تنفيذي، مدير...)",
  "clientProfilePage.noCompany": "لا توجد شركة",
  "clientProfilePage.cropTitle": "قص صورة الملف الشخصي",
  // ── Admin / Talent Profile Forms ──────────────────────────────────────────────
  "adminProfileForm.accountInfo": "معلومات الحساب",
  "talentProfileForm.talentType": "نوع الموهبة",
  "talentProfileForm.previousWork": "الأعمال السابقة",
  "talentProfileForm.experienceYears": "الخبرة (سنوات)",
  "talentProfileForm.ratesPer": "السعر لكل",
  "talentProfileForm.ratesPerPlaceholder": "مثال: لكل يوم، لكل ساعة",
  "talentProfileForm.physicalAttributes": "الصفات الجسدية",
  // ── Talent Gallery / Questions ─────────────────────────────────────────────────
  "talentGallery.title": "معرض الصور",
  "talentGallery.loadFailed": "فشل تحميل المعرض.",
  "talentGallery.uploadFailed": "فشل الرفع. حاول مرة أخرى.",
  "talentGallery.deleteFailed": "فشل حذف الصورة.",
  "talentGallery.confirmDelete": "هل تريد حذف هذه الصورة؟",
  "talentGallery.addPhotos": "إضافة صور",
  "talentGallery.uploadPhotosOne": "رفع صورة واحدة",
  "talentGallery.uploadPhotosOther": "رفع {{count}} صور",
  "talentGallery.emptyState": "لا توجد صور في المعرض بعد. اضغط للرفع.",
  "talentGallery.cropPhotoTitle": "قص الصورة",
  "talentGallery.moreAfterSuffix": "{{count}} أخرى بعدها",
  "talentQuestions.loadFailed": "فشل تحميل الأسئلة",
  "talentQuestions.waitForLoad": "يرجى الانتظار حتى يتم تحميل الأسئلة",
  "talentQuestions.answerAll": "يرجى الإجابة على جميع الأسئلة",
  "talentQuestions.title": "أسئلة التسجيل",
  // ── Talent Dashboard ───────────────────────────────────────────────────────────
  "talentDashboard.welcomeBack": "مرحبًا بعودتك",
  "talentDashboard.title": "لوحة تحكم الموهبة",
  "talentDashboard.stats.totalBlogs": "إجمالي المقالات",
  "talentDashboard.stats.approvedBlogs": "المقالات المعتمدة",
  "talentDashboard.stats.pendingBlogs": "المقالات قيد الانتظار",
  "talentDashboard.stats.castingBriefs": "طلبات الاختيار",
  "talentDashboard.pendingCount": "{{count}} قيد الانتظار",
  "talentDashboard.quickActionsTitle": "إجراءات سريعة",
  "talentDashboard.quickActionsSubtitle": "انتقل إلى أهم مهامك",
  "talentDashboard.actions.createBlogTitle": "إنشاء مقال",
  "talentDashboard.actions.createBlogDesc": "اكتب وأرسل مقالًا جديدًا",
  "talentDashboard.actions.myBlogsTitle": "مقالاتي",
  "talentDashboard.actions.myBlogsDesc": "عرض وإدارة مقالاتك",
  "talentDashboard.actions.castingBriefsDesc": "عرض الطلبات التي تم اختيارك لها",
  "talentDashboard.actions.editProfileTitle": "تعديل الملف الشخصي",
  "talentDashboard.actions.editProfileDesc": "تحديث ملفك الشخصي كموهبة",
  "talentDashboard.editBlogPostTitle": "تعديل المقال",
  "talentDashboard.createBlogPostTitle": "إنشاء مقال",
  "talentDashboard.blogFormSubtitle": "ستتم مراجعة مقالك قبل النشر",
  "talentDashboard.closeFormAria": "إغلاق النموذج",
  "talentDashboard.titlePlaceholder": "أدخل عنوان المقال",
  "talentDashboard.contentPlaceholder": "اكتب محتواك هنا…",
  "talentDashboard.removeImageAria": "إزالة الصورة",
  "talentDashboard.coverPreviewAlt": "معاينة",
  "talentDashboard.tagPlaceholder": "اكتب وسمًا ثم اضغط Enter",
  "talentDashboard.removeTagAria": "إزالة الوسم {{tag}}",
  "talentDashboard.updateBlog": "تحديث",
  "talentDashboard.submitForReview": "إرسال للمراجعة",
  "talentDashboard.briefsSelectedForOne": "طلب واحد تم اختيارك له",
  "talentDashboard.briefsSelectedForOther": "{{count}} طلبات تم اختيارك لها",
  "talentDashboard.closeBriefsAria": "إغلاق الطلبات",
  "talentDashboard.noBriefsYet": "لا توجد طلبات اختيار بعد",
  "talentDashboard.noBriefsYetSubtitle": "لم يتم اختيارك لأي طلبات بعد",
  "talentDashboard.untitledBrief": "بدون عنوان",
  "talentDashboard.selectedBadge": "تم الاختيار",
  "talentDashboard.myBlogPostsTitle": "مقالاتي",
  "talentDashboard.postsCountOne": "مقال واحد",
  "talentDashboard.postsCountOther": "{{count}} مقالات",
  "talentDashboard.closeBlogListAria": "إغلاق قائمة المقالات",
  "talentDashboard.noBlogPostsYet": "لا توجد مقالات بعد",
  "talentDashboard.createFirstBlogPost": "أنشئ مقالك الأول لتبدأ",
  "talentDashboard.recentActivityTitle": "النشاط الأخير",
  "talentDashboard.recentActivitySubtitle": "آخر أنشطة المقالات والطلبات الخاصة بك",
  "talentDashboard.noActivityYet": "لا يوجد نشاط حديث بعد",
  "talentDashboard.activityBlogApproved": "تمت الموافقة على المقال: \"{{title}}\"",
  "talentDashboard.activityBlogRejected": "تم رفض المقال: \"{{title}}\"",
  "talentDashboard.activityBlogSubmitted": "تم إرسال المقال: \"{{title}}\"",
  "talentDashboard.activityAssignedBrief": "تم تعيينك لطلب اختيار: \"{{desc}}\"",
  // ── Content Brief Form (public) ────────────────────────────────────────────────
  "contentBriefForm.fields.nameLabel": "الاسم",
  "contentBriefForm.fields.namePlaceholder": "اسمك الكامل",
  "contentBriefForm.fields.emailPlaceholder": "your.email@example.com",
  "contentBriefForm.fields.phoneLabel": "رقم الهاتف",
  "contentBriefForm.fields.phonePlaceholder": "+20 XXX XXX XXXX",
  "contentBriefForm.fields.ideaLabel": "فكرتك",
  "contentBriefForm.fields.ideaPlaceholder": "صف فكرتك للمحتوى بالتفصيل. ما القصة التي تريد أن ترويها؟ ما الرسالة؟ من هو جمهورك المستهدف؟ ما الأسلوب أو الطابع الذي تريده؟ كلما شاركتنا تفاصيل أكثر، كلما استطعنا فهم رؤيتك وتحقيقها كما تتخيلها تمامًا.",
  "contentBriefForm.fields.equipmentLabel": "المعدات أو الإنتاج المطلوب",
  "contentBriefForm.fields.equipmentPlaceholder": "أخبرنا إذا كانت لديك احتياجات معدات محددة، متطلبات إنتاج، مواقع تصوير في ذهنك، قيود زمنية، أو اعتبارات خاصة بالميزانية. هذا يساعدنا على التخطيط لأفضل أسلوب إنتاج لمشروعك.",
  "contentBriefForm.contentTypes.shortForm.title": "محتوى قصير",
  "contentBriefForm.contentTypes.shortForm.item1": "ريلز وستوريز السوشيال ميديا",
  "contentBriefForm.contentTypes.shortForm.item2": "فيديوهات وترندات تيك توك",
  "contentBriefForm.contentTypes.shortForm.item3": "محتوى إنستغرام",
  "contentBriefForm.contentTypes.shortForm.item4": "يوتيوب شورتس",
  "contentBriefForm.contentTypes.longForm.title": "محتوى طويل",
  "contentBriefForm.contentTypes.longForm.item1": "أفلام وثائقية",
  "contentBriefForm.contentTypes.longForm.item2": "فيديوهات سرد قصصي للعلامة التجارية",
  "contentBriefForm.contentTypes.longForm.item3": "عروض تقديمية للشركات",
  "contentBriefForm.contentTypes.longForm.item4": "تغطية الفعاليات",
  "contentBriefForm.contentTypes.commercial.title": "محتوى تجاري",
  "contentBriefForm.contentTypes.commercial.item1": "إعلانات المنتجات",
  "contentBriefForm.contentTypes.commercial.item2": "حملات العلامة التجارية",
  "contentBriefForm.contentTypes.commercial.item3": "محتوى بأسلوب UGC",
  "contentBriefForm.contentTypes.commercial.item4": "فيديوهات آراء العملاء",
  "contentBriefForm.contentTypes.creative.title": "مشاريع إبداعية",
  "contentBriefForm.contentTypes.creative.item1": "فيديوهات موسيقية",
  "contentBriefForm.contentTypes.creative.item2": "أعمال فنية وثقافية",
  "contentBriefForm.contentTypes.creative.item3": "محتوى تجريبي",
  "contentBriefForm.contentTypes.creative.item4": "مشاريع شخصية",
  "contentBriefForm.process.consultation.title": "الاستشارة",
  "contentBriefForm.process.consultation.description": "نناقش رؤيتك ومتطلباتك",
  "contentBriefForm.process.planning.title": "التخطيط",
  "contentBriefForm.process.planning.description": "نضع خطة إنتاج مفصلة",
  "contentBriefForm.process.production.title": "الإنتاج",
  "contentBriefForm.process.production.description": "نحول قصتك إلى واقع",
  "contentBriefForm.process.delivery.title": "التسليم",
  "contentBriefForm.process.delivery.description": "تستلم محتواك جاهزًا",
  "contentBriefForm.heroBadge": "صناعة المحتوى",
  "contentBriefForm.heroTitle": "احكِها",
  "contentBriefForm.heroTitleHighlight": "معنا",
  "contentBriefForm.heroDescription": "شاركنا رؤيتك أو فكرتك أو القصة التي كنت تنتظر لتحقيقها. كلما أخبرتنا أكثر، كلما استطعنا تشكيلها إلى شيء لا يُنسى.",
  "contentBriefForm.heroCta": "من الفكرة إلى الإنتاج، نحن هنا لتحقيق ذلك.",
  "contentBriefForm.formTitle": "شاركنا رؤيتك",
  "contentBriefForm.formSubtitle": "أخبرنا عن فكرة المحتوى الخاصة بك وسنساعدك على تحقيقها",
  "contentBriefForm.contentTypesTitle": "ما يمكننا إنشاؤه معًا",
  "contentBriefForm.processTitle": "منهجنا الإبداعي",
  "contentBriefForm.submitButton": "لنبدأ",
  "contentBriefForm.successMessage": "تم إرسال الطلب بنجاح! جارٍ التحويل...",
  "contentBriefForm.errorMessage": "فشل الإرسال. حاول مرة أخرى.",
  "contentBriefForm.infoMessage": "سنراجع فكرتك ونعود إليك خلال 24 ساعة باقتراح مفصل",
  // ── Blog Post (spotlight) ──────────────────────────────────────────────────────
  "blogPost.notFound": "المقال غير موجود.",
  "blogPost.backToBlogsArrow": "→ العودة إلى المقالات",
  "blogPost.backToBlogs": "العودة إلى المقالات",
  "blogPost.minRead": "{{minutes}} دقيقة قراءة",
  // ── Brief Details Body (shared) ────────────────────────────────────────────────
  "briefDetailsBody.projectDetails": "تفاصيل المشروع",
  "briefDetailsBody.talentRequirements": "متطلبات الموهبة",
  "briefDetailsBody.egp": "جنيه مصري",
  "briefDetailsBody.heightCm": "الطول (سم)",
  "briefDetailsBody.weightKg": "الوزن (كجم)",
  "briefDetailsBody.available": "متاح:",
  "briefDetailsBody.selectedTalents": "المواهب المختارة ({{count}})",
  "briefDetailsBody.unnamedTalent": "موهبة بدون اسم",
  "briefDetailsBody.additionalNotes": "ملاحظات إضافية",
  // ── Shared: misc components ────────────────────────────────────────────────────
  "errorBoundary.unexpectedError": "حدث خطأ غير متوقع",
  "errorBoundary.reloadPage": "إعادة تحميل الصفحة",
  "imageCropModal.defaultTitle": "قص الصورة",
  "imageCropModal.repositionHint": "اسحب لإعادة التموضع · قرّب أو باعد للتكبير",
  "imageCropModal.processing": "جارٍ المعالجة…",
  "imageCropModal.applyCrop": "تطبيق القص",
  "nationalitySelect.selectPlaceholder": "اختر الجنسية",
  "offlineBanner.backOnline": "عاد الاتصال",
  "offlineBanner.noConnection": "لا يوجد اتصال بالإنترنت",
  "pendingBanner.updateRejected": "تم رفض تحديث الملف الشخصي",
  "pendingBanner.editAndResubmit": "يمكنك تعديل التغييرات وإعادة إرسالها أدناه.",
  "pendingBanner.pendingApproval": "قيد الموافقة",
  "pendingBanner.awaitingReview": "تغييراتك في انتظار مراجعة الإدارة.",
  "protectedRoute.accessDenied": "الوصول مرفوض",
  "protectedRoute.noPermission": "ليس لديك إذن للوصول إلى هذا المورد.",
  "protectedRoute.goBackHome": "العودة إلى الرئيسية",
  "talentCartPrompt.thisTalent": "هذه الموهبة",
  "talentCartPrompt.addedToBrief": "تمت إضافة {{name}} إلى طلبك",
  "talentCartPrompt.continueBrowsing": "هل تريد متابعة اختيار المزيد من المواهب؟",
  "talentCartPrompt.keepBrowsing": "نعم، متابعة التصفح",
  "talentCartPrompt.reviewAndSubmit": "لا، مراجعة الطلب وإرساله",
  "common.selectPlaceholder": "اختر {{label}}",
  "brandLogos.title": "تعاونات مع علامات تجارية",

  // ── Contact ───────────────────────────────────────────────────────────────────
  "contact.title": "تواصل معنا",
  "contact.name": "الاسم",
  "contact.email": "البريد الإلكتروني",
  "contact.message": "رسالتك",
  "contact.privacy": "أوافق على معالجة بياناتي وفقاً لسياسة الخصوصية",
  "contact.send": "إرسال الرسالة",
  "contact.pageTitle": "تواصل مع أرتيريا - تحدث معنا",
  "contact.hero.badge": "تواصل معنا",
  "contact.hero.titlePrefix": "تواصل مع",
  "contact.hero.description": "هل تتساءل عن عالمنا المليء بالمواهب المذهلة والمحتوى الجذاب؟ نحن على بُعد رسالة واحدة! تواصل معنا في أي وقت ودعنا نحوّل رؤيتك إلى واقع.",
  "contact.form.title": "أرسل لنا رسالة",
  "contact.form.fullName": "الاسم الكامل *",
  "contact.form.fullNamePlaceholder": "اسمك الكامل",
  "contact.form.emailLabel": "البريد الإلكتروني *",
  "contact.form.phone": "رقم الهاتف",
  "contact.form.messageLabel": "الرسالة *",
  "contact.form.messagePlaceholder": "أخبرنا عن مشروعك، أسئلتك، أو كيف يمكننا مساعدتك...",
  "contact.form.sending": "جارٍ الإرسال...",
  "contact.form.successMessage": "تم إرسال رسالتك بنجاح. سنتواصل معك قريبًا.",
  "contact.form.errorMessage": "حدث خطأ ما. حاول مرة أخرى.",
  "contact.info.title": "تواصل معنا",
  "contact.info.description": "نحن هنا لمساعدتك في تحويل رؤيتك الإبداعية إلى واقع. سواء كنت تبحث عن موهبة، أو تحتاج إلى إنتاج محتوى، أو لديك أسئلة عن خدماتنا، يسعدنا أن نسمع منك.",
  "contact.info.phoneTitle": "أرقام الهاتف",
  "contact.info.primary": "الرئيسي",
  "contact.info.secondary": "الثانوي",
  "contact.info.emailTitle": "البريد الإلكتروني",
  "contact.info.generalInquiries": "استفسارات عامة",
  "contact.info.locationTitle": "الموقع",
  "contact.info.officeAddress": "عنوان المكتب",
  "contact.info.hoursTitle": "ساعات العمل",
  "contact.info.days.mon": "الإثنين",
  "contact.info.days.tue": "الثلاثاء",
  "contact.info.days.wed": "الأربعاء",
  "contact.info.days.thu": "الخميس",
  "contact.info.days.fri": "الجمعة",
  "contact.info.days.sat": "السبت",
  "contact.info.days.sun": "الأحد",
  "contact.info.closed": "مغلق",
  "contact.map.title": "زُر مكتبنا",
  "contact.map.subtitle": "يقع في قلب {{location}} - يسهل الوصول إليه وجاهز لاستقبالك",
  "contact.map.interactiveMap": "خريطة تفاعلية",
  "contact.map.openInGoogleMaps": "افتح في خرائط جوجل",
  "contact.cta.titlePrefix": "هل أنت مستعد لبدء",
  "contact.cta.titleHighlight": "رحلتك",
  "contact.cta.subtitle": "سواء كنت موهبة تتطلع للانضمام إلى شبكتنا أو علامة تجارية تبحث عن سرد قصصي أصيل، نحن هنا لتحقيق ذلك.",
  "contact.whatsapp.ariaLabel": "تحدث معنا عبر واتساب",
  "contact.whatsapp.tooltip": "تحدث معنا",

  // ── Admin: Common ────────────────────────────────────────────────────────────
  "common.cancel": "إلغاء",
  "common.save": "حفظ",
  "common.saving": "جارٍ الحفظ...",
  "common.delete": "حذف",
  "common.deleting": "جارٍ الحذف...",
  "common.edit": "تعديل",
  "common.add": "إضافة",
  "common.create": "إنشاء",
  "common.update": "تحديث",
  "common.close": "إغلاق",
  "common.confirm": "تأكيد",
  "common.actions": "الإجراءات",
  "common.search": "بحث...",
  "common.loading": "جارٍ التحميل...",
  "common.back": "رجوع",
  "common.submit": "إرسال",
  "common.yes": "نعم",
  "common.no": "لا",
  "common.name": "الاسم",
  "common.description": "الوصف",
  "common.status": "الحالة",
  "common.active": "نشط",
  "common.inactive": "غير نشط",
  "common.view": "عرض",
  "common.viewDetails": "عرض التفاصيل",
  "common.upload": "رفع",
  "common.required": "مطلوب",
  "common.optional": "اختياري",
  "common.noResults": "لا توجد نتائج",
  "common.all": "الكل",
  "common.retry": "إعادة المحاولة",
  "common.somethingWentWrong": "حدث خطأ ما",
  "common.areYouSure": "هل أنت متأكد؟",
  "common.thisActionCannotBeUndone": "لا يمكن التراجع عن هذا الإجراء.",
  "common.saveChanges": "حفظ التغييرات",
  "admin.basicInformation": "المعلومات الأساسية",

  // ── Admin: Talents & Clients ─────────────────────────────────────────────────
  "toast.talent.loadFailed": "فشل تحميل المواهب",
  "toast.talent.approved": "تمت الموافقة على الموهبة بنجاح",
  "toast.talent.approveFailed": "فشلت الموافقة على الموهبة",
  "toast.talent.rejectionReasonRequired": "يرجى تقديم سبب الرفض",
  "toast.talent.rejected": "تم رفض الموهبة",
  "toast.talent.rejectFailed": "فشل رفض الموهبة",
  "toast.talent.deleted": "تم حذف الموهبة",
  "toast.talent.deleteFailed": "فشل حذف الموهبة",
  "toast.talent.stageNameRequired": "يرجى إدخال الاسم الفني",
  "toast.talent.userRequired": "يرجى اختيار مستخدم",
  "toast.talent.created": "تم إنشاء الملف الشخصي للموهبة",
  "toast.talent.createFailed": "فشل إنشاء الملف الشخصي للموهبة",
  "toast.client.loadFailed": "فشل تحميل العملاء",
  "toast.client.approved": "تمت الموافقة على العميل",
  "toast.client.setPending": "تم تعيين حالة العميل إلى قيد الانتظار",
  "toast.client.statusUpdateFailed": "فشل تحديث الحالة",
  "toast.client.deleted": "تم حذف العميل",
  "toast.client.deleteFailed": "فشل حذف العميل",
  "admin.talentsManagement.badge": "مركز المواهب",
  "admin.dashboard.welcomeBack": "مرحباً بعودتك",
  "admin.dashboard.title": "لوحة تحكم الإدارة",
  "admin.dashboard.administrator": "مسؤول النظام",
  "admin.dashboard.totalUsers": "إجمالي المستخدمين",
  "admin.dashboard.totalTalents": "إجمالي المواهب",
  "admin.dashboard.blogs": "المدونات",
  "admin.dashboard.castingBriefs": "طلبات الكاستينج",
  "admin.dashboard.pending": "{{count}} قيد الانتظار",
  "admin.dashboard.quickActions": "إجراءات سريعة",
  "admin.dashboard.quickActionsSubtitle": "انتقل إلى أهم مهام الإدارة",
  "admin.dashboard.recentActivity": "النشاط الأخير",
  "admin.dashboard.recentActivitySubtitle": "أحدث التحديثات على منصتك",
  "admin.dashboard.noRecentActivity": "لا يوجد نشاط حديث حتى الآن",
  "admin.dashboard.newTalent": "موهبة جديدة: {{name}}",
  "admin.dashboard.newBlog": "مدونة جديدة: {{title}}",
  "admin.dashboard.newBrief": "طلب جديد: {{name}}",
  "admin.dashboard.newUser": "مستخدم جديد: {{name}}",
  "admin.dashboard.unnamed": "بدون اسم",
  "admin.dashboard.untitled": "بدون عنوان",
  "admin.dashboard.unknown": "غير معروف",
  "admin.dashboard.users": "المستخدمون",
  "admin.dashboard.usersDescription": "إدارة جميع مستخدمي المنصة",
  "admin.dashboard.talents": "المواهب",
  "admin.dashboard.talentsDescription": "الموافقة على المواهب أو رفضها",
  "admin.dashboard.clients": "العملاء",
  "admin.dashboard.clientsDescription": "عرض وإدارة حسابات العملاء",
  "admin.dashboard.blog": "المدونة",
  "admin.dashboard.blogDescription": "إنشاء ونشر المقالات",
  "admin.dashboard.briefs": "الطلبات",
  "admin.dashboard.briefsDescription": "مراجعة طلبات الكاستينج",
  "admin.dashboard.categories": "الفئات",
  "admin.dashboard.categoriesDescription": "تنظيم فئات المنصة",
  "admin.dashboard.works": "الأعمال",
  "admin.dashboard.worksDescription": "إدارة المحافظ والأعمال",
  "admin.dashboard.albums": "الألبومات",
  "admin.dashboard.albumsDescription": "إدارة صور معرض الصفحة الرئيسية",
  "admin.dashboard.content": "المحتوى",
  "admin.dashboard.contentDescription": "إدارة محتوى المنصة",
  "admin.dashboard.specialties": "التخصصات",
  "admin.dashboard.specialtiesDescription": "إدارة تخصصات المواهب",
  "admin.dashboard.questions": "الأسئلة",
  "admin.dashboard.questionsDescription": "إدارة أسئلة التسجيل",
  "admin.dashboard.profileUpdates": "تحديثات الملف الشخصي",
  "admin.dashboard.profileUpdatesDescription": "مراجعة تغييرات الملفات الشخصية المعلقة",
  "admin.dashboard.quotations": "عروض الأسعار",
  "admin.dashboard.quotationsDescription": "إدارة عروض الأسعار",
  "admin.dashboard.contactMessages": "رسائل التواصل",
  "admin.dashboard.contactMessagesDescription": "عرض الرسائل المرسلة من صفحة التواصل",
  "admin.dashboard.trustedBy": "يثق بنا",
  "admin.dashboard.trustedByDescription": "إدارة شعارات العلامات التجارية الموثوقة",
  "admin.dashboard.projectTypes": "أنواع المشاريع",
  "admin.dashboard.projectTypesDescription": "إدارة تصنيفات أنواع المشاريع",
  "admin.dashboard.aboutSection": "قسم عن أرتيريا",
  "admin.dashboard.aboutSectionDescription": "تحديث صورة ونص قسم عن أرتيريا في الصفحة الرئيسية",
  "admin.dashboard.footerSettings": "إعدادات الفوتر",
  "admin.dashboard.footerSettingsDescription": "إدارة معلومات التواصل وروابط التواصل الاجتماعي",
  "admin.dashboard.testimonials": "آراء العملاء",
  "admin.dashboard.testimonialsDescription": "إدارة آراء العملاء",
  "admin.briefsManagement.title": "طلبات الكاستينج",
  "admin.briefsManagement.subtitle": "مراجعة وإدارة طلبات الكاستينج",
  "admin.briefsManagement.totalBriefs": "إجمالي الطلبات",
  "admin.briefsManagement.stats.pending": "قيد الانتظار",
  "admin.briefsManagement.stats.inReview": "قيد المراجعة",
  "admin.briefsManagement.stats.approved": "معتمد",
  "admin.briefsManagement.stats.completed": "مكتمل",
  "admin.briefsManagement.searchPlaceholder": "ابحث في الطلبات...",
  "admin.briefsManagement.filter.allStatus": "جميع الحالات",
  "admin.briefsManagement.filter.pending": "قيد الانتظار",
  "admin.briefsManagement.filter.inReview": "قيد المراجعة",
  "admin.briefsManagement.filter.approved": "معتمد",
  "admin.briefsManagement.filter.rejected": "مرفوض",
  "admin.briefsManagement.filter.completed": "مكتمل",
  "admin.briefsManagement.empty.title": "لم يتم العثور على طلبات",
  "admin.briefsManagement.empty.subtitle": "لا توجد طلبات كاستينج تطابق عوامل التصفية",
  "admin.briefsManagement.untitledProject": "مشروع بدون عنوان",
  "admin.briefsManagement.unknownClient": "عميل غير معروف",
  "admin.briefsManagement.priorityLabel": "الأولوية",
  "admin.briefsManagement.talentsSelected": "تم اختيار {{count}} مواهب",
  "admin.talentsManagement.title": "إدارة المواهب",
  "admin.talentsManagement.subtitle": "مراجعة وإدارة طلبات المواهب",
  "admin.talentsManagement.stats.pendingReview": "قيد المراجعة",
  "admin.talentsManagement.stats.awaitingReview": "بانتظار المراجعة",
  "admin.talentsManagement.stats.approved": "معتمد",
  "admin.talentsManagement.stats.activeTalents": "المواهب النشطة",
  "admin.talentsManagement.stats.rejected": "مرفوض",
  "admin.talentsManagement.stats.notApproved": "غير معتمد",
  "admin.talentsManagement.filters.title": "الفلاتر",
  "admin.talentsManagement.filters.searchPlaceholder": "ابحث بالاسم الفني أو البريد الإلكتروني...",
  "admin.talentsManagement.filters.statusAriaLabel": "التصفية حسب الحالة",
  "admin.talentsManagement.filters.allStatus": "جميع الحالات",
  "admin.talentsManagement.filters.pending": "قيد الانتظار",
  "admin.talentsManagement.filters.approved": "معتمد",
  "admin.talentsManagement.filters.rejected": "مرفوض",
  "admin.talentsManagement.empty.title": "لم يتم العثور على مواهب",
  "admin.talentsManagement.empty.subtitle": "ابدأ بإضافة موهبة جديدة أو عدّل عوامل التصفية",
  "admin.talentsManagement.pagination.showing": "عرض",
  "admin.talentsManagement.pagination.of": "من",
  "admin.talentsManagement.pagination.talents": "مواهب",
  "admin.talentsManagement.pagination.prev": "السابق",
  "admin.talentsManagement.pagination.page": "صفحة",
  "admin.talentsManagement.pagination.next": "التالي",
  "admin.talentCard.defaultAlt": "موهبة",
  "admin.talentCard.unnamedTalent": "موهبة بدون اسم",
  "admin.talentCard.dob": "تاريخ الميلاد",
  "admin.talentCard.gender": "الجنس",
  "admin.talentCard.experience": "الخبرة",
  "admin.talentCard.years": "سنوات",
  "admin.talentCard.categories": "الفئات",
  "admin.talentCard.approve": "موافقة",
  "admin.talentDetailsModal.title": "الملف الشخصي للموهبة",
  "admin.talentDetailsModal.fullName": "الاسم الكامل",
  "admin.talentDetailsModal.codeName": "الاسم الفني",
  "admin.talentDetailsModal.email": "البريد الإلكتروني",
  "admin.talentDetailsModal.phone": "الهاتف",
  "admin.talentDetailsModal.talentType": "نوع الموهبة",
  "admin.talentDetailsModal.memberSince": "عضو منذ",
  "admin.talentDetailsModal.approvedAt": "تاريخ الموافقة",
  "admin.talentDetailsModal.personalInformation": "المعلومات الشخصية",
  "admin.talentDetailsModal.age": "العمر",
  "admin.talentDetailsModal.ageValue": "{{age}} سنة",
  "admin.talentDetailsModal.dateOfBirth": "تاريخ الميلاد",
  "admin.talentDetailsModal.gender": "الجنس",
  "admin.talentDetailsModal.nationality": "الجنسية",
  "admin.talentDetailsModal.city": "المدينة",
  "admin.talentDetailsModal.physicalAttributes": "الصفات الجسدية",
  "admin.talentDetailsModal.height": "الطول",
  "admin.talentDetailsModal.heightValue": "{{height}} سم",
  "admin.talentDetailsModal.weight": "الوزن",
  "admin.talentDetailsModal.weightValue": "{{weight}} كجم",
  "admin.talentDetailsModal.eyeColor": "لون العين",
  "admin.talentDetailsModal.hairColor": "لون الشعر",
  "admin.talentDetailsModal.hairType": "نوع الشعر",
  "admin.talentDetailsModal.skinTone": "لون البشرة",
  "admin.talentDetailsModal.bodyType": "نوع الجسم",
  "admin.talentDetailsModal.professional": "المعلومات المهنية",
  "admin.talentDetailsModal.experience": "الخبرة",
  "admin.talentDetailsModal.experienceYear": "{{count}} سنة",
  "admin.talentDetailsModal.experienceYears": "{{count}} سنوات",
  "admin.talentDetailsModal.rate": "السعر",
  "admin.talentDetailsModal.socialMediaAdminOnly": "وسائل التواصل الاجتماعي (للإدارة فقط)",
  "admin.talentDetailsModal.instagram": "إنستغرام",
  "admin.talentDetailsModal.facebook": "فيسبوك",
  "admin.talentDetailsModal.tiktok": "تيك توك",
  "admin.talentDetailsModal.skillsAndCategories": "المهارات والفئات",
  "admin.talentDetailsModal.categories": "الفئات",
  "admin.talentDetailsModal.skills": "المهارات",
  "admin.talentDetailsModal.languages": "اللغات",
  "admin.talentDetailsModal.specialties": "التخصصات",
  "admin.talentDetailsModal.bio": "نبذة تعريفية",
  "admin.talentDetailsModal.portfolioDescription": "وصف الأعمال",
  "admin.talentDetailsModal.portfolioImages": "صور الأعمال",
  "admin.talentDetailsModal.portfolioImageAlt": "صورة الأعمال {{index}}",
  "admin.talentDetailsModal.portfolioVideos": "فيديوهات الأعمال",
  "admin.talentDetailsModal.videoLabel": "فيديو {{index}}",
  "admin.talentDetailsModal.rejectionReason": "سبب الرفض",
  "admin.talentDetailsModal.rejectionReasonOptional": "سبب الرفض (اختياري)",
  "admin.talentDetailsModal.rejectionReasonPlaceholder": "أدخل سبب الرفض...",
  "admin.talentDetailsModal.confirmDelete": "هل تريد حذف هذه الموهبة؟",
  "admin.talentDetailsModal.editProfile": "تعديل الملف الشخصي",
  "admin.talentDetailsModal.reject": "رفض",
  "admin.talentDetailsModal.approve": "موافقة",
  "admin.clientsManagement.badge": "مركز العملاء",
  "admin.clientsManagement.title": "إدارة العملاء",
  "admin.clientsManagement.subtitle": "عرض وإدارة حسابات العملاء المسجلين",
  "admin.clientsManagement.stats.totalClients": "إجمالي العملاء",
  "admin.clientsManagement.searchPlaceholder": "ابحث بالاسم أو البريد الإلكتروني...",
  "admin.clientsManagement.empty.title": "لم يتم العثور على عملاء",
  "admin.clientsManagement.empty.subtitle": "عدّل بحثك وحاول مرة أخرى",
  "admin.clientsManagement.pagination.showing": "عرض",
  "admin.clientsManagement.pagination.of": "من",
  "admin.clientsManagement.pagination.clients": "عملاء",
  "admin.clientsManagement.pagination.prev": "السابق",
  "admin.clientsManagement.pagination.page": "صفحة",
  "admin.clientsManagement.pagination.next": "التالي",
  "admin.clientDetailsModal.joined": "انضم في {{date}}",
  "admin.clientDetailsModal.email": "البريد الإلكتروني",
  "admin.clientDetailsModal.phone": "الهاتف",
  "admin.clientDetailsModal.company": "الشركة",
  "admin.clientDetailsModal.companyType": "نوع الشركة",
  "admin.clientDetailsModal.title": "المسمى الوظيفي",
  "admin.clientDetailsModal.whatsapp": "واتساب",
  "admin.clientDetailsModal.editProfile": "تعديل الملف الشخصي",

  // ── Admin: Quotation Details Modal ────────────────────────────────────────
  "admin.quotationDetailsModal.email": "البريد الإلكتروني",
  "admin.quotationDetailsModal.phone": "الهاتف",
  "admin.quotationDetailsModal.idea": "الفكرة",
  "admin.quotationDetailsModal.equipment": "المعدات",
  "admin.quotationDetailsModal.equipmentProduction": "المعدات / احتياجات الإنتاج",
  "admin.quotationDetailsModal.submitted": "تم الإرسال في {{date}}",
  "admin.quotationDetailsModal.deleteTitle": "حذف عرض السعر هذا؟",
  "admin.quotationDetailsModal.actions.approve": "موافقة",
  "admin.quotationDetailsModal.actions.pending": "تعليق",
  "admin.quotationDetailsModal.actions.reject": "رفض",

  // ── Admin: User Modal ──────────────────────────────────────────────────────
  "admin.userModal.talentTypeModeling": "عارضة أزياء",
  "admin.userModal.talentTypeContentCreator": "صانع محتوى",
  "admin.userModal.talentTypeBoth": "كلاهما",
  "admin.userModal.addTitle": "إضافة مستخدم جديد",
  "admin.userModal.firstNameLabel": "الاسم الأول *",
  "admin.userModal.firstNamePlaceholder": "الاسم الأول",
  "admin.userModal.lastNameLabel": "اسم العائلة *",
  "admin.userModal.lastNamePlaceholder": "اسم العائلة",
  "admin.userModal.emailLabel": "البريد الإلكتروني *",
  "admin.userModal.roleLabel": "الدور *",
  "admin.userModal.roleClient": "عميل",
  "admin.userModal.roleTalent": "موهبة",
  "admin.userModal.roleAdmin": "مدير",
  "admin.userModal.passwordLabel": "كلمة المرور *",
  "admin.userModal.confirmPasswordLabel": "تأكيد كلمة المرور *",
  "admin.userModal.clientInformation": "معلومات العميل",
  "admin.userModal.companyLabel": "الشركة *",
  "admin.userModal.companyPlaceholder": "اسم الشركة",
  "admin.userModal.companyTypeLabel": "نوع الشركة",
  "admin.userModal.companyTypePlaceholder": "مثال: وكالة، علامة تجارية، شركة إنتاج",
  "admin.userModal.titleLabel": "المسمى الوظيفي",
  "admin.userModal.titlePlaceholder": "مثال: الرئيس التنفيذي، مدير تسويق",
  "admin.userModal.talentTypeSection": "نوع الموهبة",
  "admin.userModal.talentTypeLabel": "نوع الموهبة *",
  "admin.userModal.dobLabel": "تاريخ الميلاد *",
  "admin.userModal.contentCreatorTypesLabel": "أنواع صانع المحتوى *",
  "admin.userModal.loadingTypes": "جارٍ تحميل الأنواع...",
  "admin.userModal.cityLabel": "المدينة",
  "admin.userModal.genderLabel": "الجنس *",
  "admin.userModal.specialtiesLabel": "التخصصات *",
  "admin.userModal.experienceLevelLabel": "مستوى الخبرة *",
  "admin.userModal.physicalDetails": "التفاصيل الجسدية",
  "admin.userModal.heightLabel": "الطول (سم)",
  "admin.userModal.weightLabel": "الوزن (كجم)",
  "admin.userModal.tshirtLabel": "مقاس التيشيرت",
  "admin.userModal.pantLabel": "مقاس البنطال",
  "admin.userModal.shoeSizeLabel": "مقاس الحذاء",
  "admin.userModal.skinToneLabel": "لون البشرة",
  "admin.userModal.hairTypeLabel": "نوع الشعر",
  "admin.userModal.eyeColorLabel": "لون العين",
  "admin.userModal.hairColorLabel": "لون الشعر",
  "admin.userModal.bodyTypeLabel": "شكل الجسم",
  "admin.userModal.bioLabel": "نبذة تعريفية",
  "admin.userModal.bioPlaceholder": "نبذة مختصرة...",
  "admin.userModal.ratesLabel": "الأسعار (جنيه / 12 ساعة)",
  "admin.userModal.ratesPlaceholder": "مثال: 500",
  "admin.userModal.createUserButton": "إنشاء مستخدم",
  "admin.userModal.whatsappLabel": "رقم واتساب",

  // ── Admin: Album Modal ─────────────────────────────────────────────────────
  "admin.albumModal.addImage": "إضافة صورة",
  "admin.albumModal.addImagesCount": "إضافة {{count}} صور",
  "admin.albumModal.addMore": "إضافة المزيد",
  "admin.albumModal.browse": "تصفح",
  "admin.albumModal.change": "تغيير",
  "admin.albumModal.closeModal": "إغلاق",
  "admin.albumModal.cropTitle": "قص الصورة",
  "admin.albumModal.cropTitleWithMore": "قص الصورة (+{{count}} أخرى)",
  "admin.albumModal.currentImage": "الصورة الحالية",
  "admin.albumModal.editAlbumImage": "تعديل صورة الألبوم",
  "admin.albumModal.image": "صورة",
  "admin.albumModal.imageTooLarge": "{{name}} كبيرة جدًا (الحد الأقصى {{maxMb}} ميجابايت)",
  "admin.albumModal.images": "صور",
  "admin.albumModal.multiplePhotosHint": "يمكنك اختيار عدة صور دفعة واحدة",
  "admin.albumModal.newAlbumImages": "صور الألبوم الجديدة",
  "admin.albumModal.noFileSelected": "لم يتم اختيار ملف",
  "admin.albumModal.noFilesSelected": "لم يتم اختيار ملفات",
  "admin.albumModal.orderLabel": "الترتيب",
  "admin.albumModal.photosSelected": "تم اختيار {{count}} صورة",
  "admin.albumModal.processing": "جارٍ المعالجة...",
  "admin.albumModal.removeFile": "إزالة الملف",
  "admin.albumModal.removeImageAt": "إزالة الصورة",
  "admin.albumModal.replace": "استبدال",
  "admin.albumModal.saveChanges": "حفظ التغييرات",
  "admin.albumModal.startingOrderHint": "ترتيب البداية لهذه الصور",
  "admin.albumModal.titleLabel": "العنوان",
  "admin.albumModal.titlePlaceholder": "أدخل عنوانًا",
  "admin.albumModal.updateDetails": "تحديث التفاصيل",
  "admin.albumModal.uploadImagesHint": "اسحب وأفلت الصور هنا، أو انقر للتصفح",
  "admin.albumModal.uploading": "جارٍ الرفع...",
  "admin.albumModal.uploadingPhotos": "جارٍ رفع الصور...",

  // ── Admin: Albums Management ───────────────────────────────────────────────
  "admin.albumsManagement.addFirstImage": "أضف أول صورة",
  "admin.albumsManagement.addImage": "إضافة صورة",
  "admin.albumsManagement.addNewImage": "إضافة صورة جديدة",
  "admin.albumsManagement.clear": "مسح",
  "admin.albumsManagement.deleteAlbumImage": "حذف صورة الألبوم هذه؟",
  "admin.albumsManagement.editAlbumImage": "تعديل صورة الألبوم",
  "admin.albumsManagement.galleryHub": "مركز المعرض",
  "admin.albumsManagement.noAlbumsFound": "لم يتم العثور على ألبومات",
  "admin.albumsManagement.order": "الترتيب",
  "admin.albumsManagement.searchPlaceholder": "البحث في الألبومات...",
  "admin.albumsManagement.subtitle": "إدارة ألبومات الصور والمعارض",
  "admin.albumsManagement.title": "إدارة الألبومات",
  "admin.albumsManagement.totalImages": "إجمالي الصور",
  "admin.albumsManagement.untitled": "بدون عنوان",

  // ── Admin: Blog Editor ─────────────────────────────────────────────────────
  "admin.blogEditor.createTitle": "إنشاء مقال مدونة",
  "admin.blogEditor.editTitle": "تعديل مقال المدونة",
  "admin.blogEditor.label": "مقال المدونة",
  "admin.blogEditor.subtitle": "كتابة ونشر محتوى Spotlight",
  "admin.blogEditor.titleLabel": "العنوان *",
  "admin.blogEditor.titlePlaceholder": "أدخل عنوان المقال",
  "admin.blogEditor.slugLabel": "الرابط المختصر",
  "admin.blogEditor.slugAutoGenerated": "يُنشأ تلقائيًا من العنوان",
  "admin.blogEditor.categoryLabel": "التصنيف *",
  "admin.blogEditor.selectCategory": "اختر تصنيفًا",
  "admin.blogEditor.statusLabel": "الحالة *",
  "admin.blogEditor.coverImageSection": "صورة الغلاف",
  "admin.blogEditor.coverImageFormat": "JPG, PNG · يُفضّل بنسبة 16:9",
  "admin.blogEditor.changeImage": "تغيير الصورة",
  "admin.blogEditor.removeCoverImage": "إزالة صورة الغلاف",
  "admin.blogEditor.contentSection": "المحتوى",
  "admin.blogEditor.contentLabel": "المحتوى *",
  "admin.blogEditor.introOptional": "(اختياري)",
  "admin.blogEditor.introPlaceholder": "ملخص مختصر لمقالك...",
  "admin.blogEditor.introHint": "يظهر في نتائج البحث والخلاصات",
  "admin.blogEditor.markdownHint": "يدعم تنسيق Markdown",
  "admin.blogEditor.tagsMetadataSection": "الوسوم والبيانات الوصفية",
  "admin.blogEditor.updateBlogButton": "تحديث المقال",
  "admin.blogEditor.publishBlogButton": "نشر المقال",
  "admin.blogEditor.cropCoverTitle": "قص صورة الغلاف",

  // ── Admin: Blogs Management ────────────────────────────────────────────────
  // ── Admin: About Section Settings ──────────────────────────────────────────
  "admin.aboutSectionSettings.title": "صورة قسم من نحن",
  "admin.aboutSectionSettings.subtitle": "إدارة الصورة ونص البطاقة الظاهرة في قسم \"من نحن\" بالصفحة الرئيسية.",
  "admin.aboutSectionSettings.sectionImageLabel": "صورة القسم",
  "admin.aboutSectionSettings.clickToUploadImage": "اضغط لرفع صورة",
  "admin.aboutSectionSettings.changeImage": "تغيير الصورة",
  "admin.aboutSectionSettings.recommendedRatio": "يُفضّل نسبة عمودية (4:5)، بحد أدنى 800×1000 بكسل",
  "admin.aboutSectionSettings.cardTitleLabel": "عنوان البطاقة",
  "admin.aboutSectionSettings.cardSubtitleLabel": "العنوان الفرعي للبطاقة",
  "admin.aboutSectionSettings.previewLabel": "معاينة",
  "admin.aboutSectionSettings.cropTitle": "قص صورة قسم من نحن",

  // ── Admin: Footer Settings ─────────────────────────────────────────────────
  "admin.footerSettings.title": "إعدادات الفوتر",
  "admin.footerSettings.subtitle": "إدارة معلومات التواصل وروابط التواصل الاجتماعي الظاهرة في تذييل الموقع.",
  "admin.footerSettings.scopeNote": "تُستخدم هذه المعلومات أيضًا في قسم \"تواصل معنا\" في صفحة التواصل — حدّثها هنا مرة واحدة.",
  "admin.footerSettings.contactSection": "معلومات التواصل",
  "admin.footerSettings.emailLabel": "البريد الإلكتروني",
  "admin.footerSettings.phoneLabel": "الهاتف الأساسي",
  "admin.footerSettings.secondaryPhoneLabel": "الهاتف الثانوي",
  "admin.footerSettings.mapUrlLabel": "الموقع على الخريطة",
  "admin.footerSettings.addressLabel": "عنوان المكتب",
  "admin.footerSettings.addressHint": "هذا هو نص العنوان الظاهر في الفوتر وصفحة التواصل — الدبوس على الخريطة أعلاه يحدد رابط الخريطة فقط.",
  "admin.footerSettings.hoursSection": "ساعات العمل",
  "admin.footerSettings.businessHoursHint": "حدد الأيام التي تعمل بها واكتب ساعات العمل لكل منها. الأيام غير المحددة تظهر كـ \"مغلق\".",
  "admin.footerSettings.days.mon": "الإثنين",
  "admin.footerSettings.days.tue": "الثلاثاء",
  "admin.footerSettings.days.wed": "الأربعاء",
  "admin.footerSettings.days.thu": "الخميس",
  "admin.footerSettings.days.fri": "الجمعة",
  "admin.footerSettings.days.sat": "السبت",
  "admin.footerSettings.days.sun": "الأحد",
  "admin.footerSettings.socialSection": "روابط التواصل الاجتماعي",
  "admin.footerSettings.socialHint": "اترك الحقل فارغًا لعرضه كـ \"قريبًا\" بدلاً من رابط.",

  // ── Admin: Location Picker ─────────────────────────────────────────────────
  "admin.locationPicker.searchPlaceholder": "ابحث عن عنوان...",
  "admin.locationPicker.searchButton": "بحث",
  "admin.locationPicker.searching": "جارٍ البحث...",
  "admin.locationPicker.noResults": "لم يتم العثور على موقع لهذا البحث.",
  "admin.locationPicker.searchFailed": "فشل البحث. حاول مرة أخرى.",
  "admin.locationPicker.hint": "انقر على الخريطة أو اسحب الدبوس لتحديد الموقع الدقيق الظاهر في تذييل الموقع.",

  // ── Admin: Categories Management ───────────────────────────────────────────
  "admin.categoriesManagement.contentHubBadge": "مركز المحتوى",
  "admin.categoriesManagement.title": "إدارة تصنيفات المقالات",
  "admin.categoriesManagement.subtitle": "تنظيم وإدارة جميع تصنيفات المحتوى",
  "admin.categoriesManagement.createButton": "إنشاء تصنيف",
  "admin.categoriesManagement.statTotal": "إجمالي التصنيفات",
  "admin.categoriesManagement.statResults": "نتائج البحث",
  "admin.categoriesManagement.statEmpty": "تصنيفات فارغة",
  "admin.categoriesManagement.searchPlaceholder": "ابحث في التصنيفات...",
  "admin.categoriesManagement.noneFound": "لم يتم العثور على تصنيفات",
  "admin.categoriesManagement.startCreating": "ابدأ بإنشاء تصنيف جديد",
  "admin.categoriesManagement.slugLabel": "الرابط المختصر",
  "admin.categoriesManagement.createdLabel": "تاريخ الإنشاء",
  "admin.categoriesManagement.deleteConfirmTitle": "حذف التصنيف؟",

  // ── Admin: Category Modal ──────────────────────────────────────────────────
  "admin.categoryModal.label": "تصنيف",
  "admin.categoryModal.editTitle": "تعديل التصنيف",
  "admin.categoryModal.nameLabel": "اسم التصنيف *",
  "admin.categoryModal.namePlaceholder": "أدخل اسم التصنيف...",

  // ── Admin: Testimonials Management ─────────────────────────────────────────
  "admin.testimonialsManagement.badge": "آراء العملاء",
  "admin.testimonialsManagement.title": "الشهادات",
  "admin.testimonialsManagement.subtitle": "إدارة شهادات العملاء الظاهرة في صفحة أعمالنا",
  "admin.testimonialsManagement.addButton": "إضافة شهادة",
  "admin.testimonialsManagement.statTotal": "إجمالي الشهادات",
  "admin.testimonialsManagement.searchPlaceholder": "ابحث بالاسم أو الشركة أو المشروع...",
  "admin.testimonialsManagement.noneFound": "لم يتم العثور على شهادات",
  "admin.testimonialsManagement.addFirst": "أضف أول شهادة عميل",
  "admin.testimonialsManagement.projectLabel": "المشروع",
  "admin.testimonialsManagement.deleteConfirmTitle": "حذف الشهادة؟",

  // ── Admin: Testimonial Modal ───────────────────────────────────────────────
  "admin.testimonialModal.editTitle": "تعديل الشهادة",
  "admin.testimonialModal.nameLabel": "الاسم *",
  "admin.testimonialModal.jobTitleLabel": "المسمى الوظيفي *",
  "admin.testimonialModal.companyLabel": "الشركة *",
  "admin.testimonialModal.projectLabel": "المشروع *",
  "admin.testimonialModal.quoteLabel": "الاقتباس *",
  "admin.testimonialModal.quotePlaceholder": "ماذا قال العميل عن العمل مع أرتيريا؟",
  "admin.testimonialModal.ratingLabel": "التقييم",
  "admin.testimonialModal.updateButton": "تحديث",

  // ── Admin: Profile Update Requests ─────────────────────────────────────────
  "admin.profileUpdateRequests.title": "طلبات تحديث الملف الشخصي",
  "admin.profileUpdateRequests.pendingBadge": "{{count}} قيد الانتظار",
  "admin.profileUpdateRequests.noneFound": "لا توجد طلبات تحديث ملف شخصي معلّقة",
  "admin.profileUpdateRequests.fieldsChangedOne": "تغيير حقل واحد · {{date}}",
  "admin.profileUpdateRequests.fieldsChangedOther": "{{count}} حقول متغيّرة · {{date}}",
  "admin.profileUpdateRequests.reviewButton": "مراجعة",

  // ── Admin: Profile Update Compare ──────────────────────────────────────────
  "admin.profileUpdateCompare.title": "مراجعة تحديث الملف الشخصي",
  "admin.profileUpdateCompare.changeOne": "تغيير واحد",
  "admin.profileUpdateCompare.changeOther": "{{count}} تغييرات",
  "admin.profileUpdateCompare.noChangedFields": "لم يتم العثور على حقول متغيّرة في هذا الطلب.",
  "admin.profileUpdateCompare.profileImageLabel": "صورة الملف الشخصي",
  "admin.profileUpdateCompare.changedBadge": "تم التغيير",
  "admin.profileUpdateCompare.beforeLabel": "قبل",
  "admin.profileUpdateCompare.afterLabel": "بعد",
  "admin.profileUpdateCompare.noImage": "لا توجد صورة",
  "admin.profileUpdateCompare.rejectionReasonLabel": "سبب الرفض",
  "admin.profileUpdateCompare.rejectionReasonPlaceholder": "اشرح سبب رفض هذا التحديث (بحد أدنى {{min}} أحرف)...",
  "admin.profileUpdateCompare.requiredField": "حقل مطلوب",
  "admin.profileUpdateCompare.readyToSubmit": "✓ جاهز للإرسال",
  "admin.profileUpdateCompare.moreCharactersNeeded": "يلزم {{count}} أحرف إضافية",
  "admin.profileUpdateCompare.rejectButton": "رفض",
  "admin.profileUpdateCompare.approveButton": "موافقة",
  "admin.profileUpdateCompare.confirmReject": "تأكيد الرفض",

  "admin.blogsManagement.approveTitle": "الموافقة على هذا المقال؟",
  "admin.blogsManagement.clearFilters": "مسح الفلاتر",
  "admin.blogsManagement.clearFiltersButton": "مسح الفلاتر",
  "admin.blogsManagement.colBlogPost": "المقال",
  "admin.blogsManagement.colCategory": "الفئة",
  "admin.blogsManagement.colCreated": "تاريخ الإنشاء",
  "admin.blogsManagement.createFirstBlog": "أنشئ أول مقال مدونة",
  "admin.blogsManagement.deleteConfirmTitle": "حذف هذا المقال؟",
  "admin.blogsManagement.filterActive": "نشط",
  "admin.blogsManagement.filtersHeading": "الفلاتر",
  "admin.blogsManagement.itemsOption": "{{count}} عناصر",
  "admin.blogsManagement.newBlogPost": "مقال جديد",
  "admin.blogsManagement.next": "التالي",
  "admin.blogsManagement.noBlogsFound": "لم يتم العثور على مقالات",
  "admin.blogsManagement.noResultsFilters": "لا توجد نتائج تطابق الفلاتر",
  "admin.blogsManagement.ofLabel": "من",
  "admin.blogsManagement.pageLabel": "صفحة",
  "admin.blogsManagement.pendingLabel": "قيد الانتظار",
  "admin.blogsManagement.pendingSub": "بانتظار المراجعة",
  "admin.blogsManagement.perPageLabel": "لكل صفحة",
  "admin.blogsManagement.previous": "السابق",
  "admin.blogsManagement.publishedLabel": "منشور",
  "admin.blogsManagement.publishedSub": "مباشر على الموقع",
  "admin.blogsManagement.rejectTitle": "رفض هذا المقال؟",
  "admin.blogsManagement.rejectedLabel": "مرفوض",
  "admin.blogsManagement.rejectedSub": "غير منشور",
  "admin.blogsManagement.searchBlogsLabel": "البحث في المقالات",
  "admin.blogsManagement.searchPlaceholder": "البحث في المقالات...",
  "admin.blogsManagement.showingLabel": "عرض",
  "admin.blogsManagement.startCreating": "ابدأ في إنشاء المحتوى",
  "admin.blogsManagement.statusAll": "الكل",
  "admin.blogsManagement.statusApproved": "موافق عليه",
  "admin.blogsManagement.statusPending": "قيد الانتظار",
  "admin.blogsManagement.statusRejected": "مرفوض",
  "admin.blogsManagement.subtitle": "إدارة مقالات المدونة ومحتوى Spotlight",
  "admin.blogsManagement.title": "إدارة المدونة",
  "admin.blogsManagement.viewTitle": "عرض المقال",

  // ── Admin: Brief Details Modal ─────────────────────────────────────────────
  "admin.briefDetailsModal.clientInformation": "معلومات العميل",
  "admin.briefDetailsModal.currentWorkflowStatus": "حالة سير العمل الحالية",
  "admin.briefDetailsModal.email": "البريد الإلكتروني",
  "admin.briefDetailsModal.phone": "الهاتف",
  "admin.briefDetailsModal.quickActions": "إجراءات سريعة",
  "admin.briefDetailsModal.title": "تفاصيل طلب الكاستينج",
  "admin.briefDetailsModal.updating": "جارٍ التحديث...",
  "admin.briefDetailsModal.urgencyLevel": "مستوى الأولوية",
  "admin.briefDetailsModal.actions.inReview": "وضع قيد المراجعة",
  "admin.briefDetailsModal.actions.approve": "موافقة",
  "admin.briefDetailsModal.actions.reject": "رفض",
  "admin.briefDetailsModal.actions.complete": "وضع كمكتمل",

  // ── Admin: Content Edit Modal ──────────────────────────────────────────────
  "admin.contentEditModal.bothVideoWarning": "يمكنك استخدام مصدر فيديو واحد فقط — قم بإزالة أحدهما قبل الحفظ",
  "admin.contentEditModal.categoryLabel": "الفئة",
  "admin.contentEditModal.categoryPlaceholder": "مثال: الأكثر رواجًا، مميز",
  "admin.contentEditModal.charsCount": "{{count}} حرفًا",
  "admin.contentEditModal.clickOrDrag": "انقر أو اسحب ملف فيديو هنا",
  "admin.contentEditModal.createTitle": "إضافة محتوى",
  "admin.contentEditModal.currentVideo": "الفيديو الحالي",
  "admin.contentEditModal.descriptionLabel": "الوصف",
  "admin.contentEditModal.descriptionPlaceholder": "اكتب وصفًا مختصرًا...",
  "admin.contentEditModal.discard": "تجاهل",
  "admin.contentEditModal.discardChangesText": "لديك تغييرات غير محفوظة. هل أنت متأكد أنك تريد تجاهلها؟",
  "admin.contentEditModal.discardChangesTitle": "تجاهل التغييرات؟",
  "admin.contentEditModal.dropItHere": "أفلته هنا",
  "admin.contentEditModal.editTitle": "تعديل المحتوى",
  "admin.contentEditModal.externalUrlLabel": "رابط فيديو خارجي",
  "admin.contentEditModal.fillDetails": "املأ التفاصيل أدناه",
  "admin.contentEditModal.idLabel": "المعرف: {{id}}",
  "admin.contentEditModal.keepEditing": "متابعة التعديل",
  "admin.contentEditModal.metricLikes": "الإعجابات",
  "admin.contentEditModal.metricShares": "المشاركات",
  "admin.contentEditModal.metricViews": "المشاهدات",
  "admin.contentEditModal.metrics": "الإحصائيات",
  "admin.contentEditModal.newUpload": "رفع جديد",
  "admin.contentEditModal.remove": "إزالة",
  "admin.contentEditModal.saveChanges": "حفظ التغييرات",
  "admin.contentEditModal.titleLabel": "العنوان",
  "admin.contentEditModal.titlePlaceholder": "أدخل عنوانًا",
  "admin.contentEditModal.uploadComplete": "اكتمل الرفع",
  "admin.contentEditModal.uploadFailedLabel": "فشل الرفع",
  "admin.contentEditModal.uploadFileLabel": "رفع ملف",
  "admin.contentEditModal.uploadingVideo": "جارٍ رفع الفيديو...",
  "admin.contentEditModal.videoFormatsHint": "الصيغ المدعومة: MP4، WebM، MOV",
  "admin.contentEditModal.videoSources": "مصادر الفيديو",
  "admin.contentEditModal.videoTooLarge": "حجم ملف الفيديو كبير جدًا",
  "admin.contentEditModal.videoUrlPlaceholder": "https://...",

  // ── Admin: Contents Management ─────────────────────────────────────────────
  "admin.contentsManagement.addContent": "إضافة محتوى",
  "admin.contentsManagement.addFirstContent": "أضف أول محتوى",
  "admin.contentsManagement.clickToPlay": "انقر للتشغيل",
  "admin.contentsManagement.deleteConfirmTitle": "حذف هذا المحتوى؟",
  "admin.contentsManagement.likes": "الإعجابات",
  "admin.contentsManagement.noContentFound": "لم يتم العثور على محتوى",
  "admin.contentsManagement.noVideo": "لا يوجد فيديو",
  "admin.contentsManagement.searchPlaceholder": "البحث في المحتوى...",
  "admin.contentsManagement.shares": "المشاركات",
  "admin.contentsManagement.startAdding": "ابدأ بإضافة المحتوى",
  "admin.contentsManagement.subtitle": "إدارة الفيديوهات والمحتوى الإعلامي",
  "admin.contentsManagement.title": "إدارة المحتوى",
  "admin.contentsManagement.tryAdjustingSearch": "حاول تعديل بحثك",
  "admin.contentsManagement.views": "المشاهدات",

  // ── Admin: Contents New ────────────────────────────────────────────────────
  "admin.contentsNew.backToContent": "العودة إلى المحتوى",
  "admin.contentsNew.basicInformation": "المعلومات الأساسية",
  "admin.contentsNew.categoryLabel": "الفئة",
  "admin.contentsNew.createContentTitle": "إنشاء محتوى",
  "admin.contentsNew.descriptionLabel": "الوصف",
  "admin.contentsNew.descriptionPlaceholder": "اكتب وصفًا مختصرًا...",
  "admin.contentsNew.dropOrBrowse": "أفلت ملفًا هنا، أو انقر للتصفح",
  "admin.contentsNew.dropToUpload": "أفلت للرفع",
  "admin.contentsNew.editContentTitle": "تعديل المحتوى",
  "admin.contentsNew.editingLabel": "التعديل",
  "admin.contentsNew.externalVideoUrlLabel": "رابط فيديو خارجي",
  "admin.contentsNew.fillRequiredFields": "يرجى ملء الحقول المطلوبة",
  "admin.contentsNew.likes": "الإعجابات",
  "admin.contentsNew.media": "الوسائط",
  "admin.contentsNew.metrics": "الإحصائيات",
  "admin.contentsNew.newContentLabel": "محتوى جديد",
  "admin.contentsNew.orUseUrl": "أو استخدم رابطًا بدلاً من ذلك",
  "admin.contentsNew.publishContent": "نشر المحتوى",
  "admin.contentsNew.publishing": "جارٍ النشر...",
  "admin.contentsNew.readyToPublish": "جاهز للنشر",
  "admin.contentsNew.removeVideo": "إزالة الفيديو",
  "admin.contentsNew.removeVideoToUseUrl": "أزل الفيديو المرفوع لاستخدام رابط بدلاً منه",
  "admin.contentsNew.selectCategory": "اختر فئة",
  "admin.contentsNew.selectedVideoFallback": "الفيديو المحدد",
  "admin.contentsNew.shares": "المشاركات",
  "admin.contentsNew.titleLabel": "العنوان",
  "admin.contentsNew.titlePlaceholder": "أدخل عنوانًا",
  "admin.contentsNew.tryDifferentFile": "جرّب ملفًا آخر",
  "admin.contentsNew.updateContent": "تحديث المحتوى",
  "admin.contentsNew.updating": "جارٍ التحديث...",
  "admin.contentsNew.uploadFailedDefault": "فشل الرفع. يرجى المحاولة مرة أخرى.",
  "admin.contentsNew.uploadFailedLabel": "فشل الرفع",
  "admin.contentsNew.uploadVideo": "رفع فيديو",
  "admin.contentsNew.uploadingVideo": "جارٍ رفع الفيديو...",
  "admin.contentsNew.videoFormatsHint": "الصيغ المدعومة: MP4، WebM، MOV",
  "admin.contentsNew.videoTooLarge": "حجم ملف الفيديو كبير جدًا",
  "admin.contentsNew.videoUploadedSuccess": "تم رفع الفيديو بنجاح",
  "admin.contentsNew.videoUrlPlaceholder": "https://...",
  "admin.contentsNew.views": "المشاهدات",

  // ── Admin: Edit User ────────────────────────────────────────────────────────
  "admin.editUser.addLanguage": "إضافة لغة",
  "admin.editUser.basicInformation": "المعلومات الأساسية",
  "admin.editUser.bio": "نبذة",
  "admin.editUser.bioPlaceholder": "اكتب نبذة مختصرة...",
  "admin.editUser.bodyType": "نوع الجسم",
  "admin.editUser.changePhoto": "تغيير الصورة",
  "admin.editUser.city": "المدينة",
  "admin.editUser.clientInformation": "معلومات العميل",
  "admin.editUser.clientTitle": "عميل",
  "admin.editUser.codeName": "الاسم الفني",
  "admin.editUser.company": "الشركة",
  "admin.editUser.companyType": "نوع الشركة",
  "admin.editUser.dateOfBirth": "تاريخ الميلاد",
  "admin.editUser.experienceYears": "الخبرة (سنوات)",
  "admin.editUser.eyeColor": "لون العين",
  "admin.editUser.female": "أنثى",
  "admin.editUser.gallery": "المعرض",
  "admin.editUser.gender": "الجنس",
  "admin.editUser.hairColor": "لون الشعر",
  "admin.editUser.hairType": "نوع الشعر",
  "admin.editUser.heightCm": "الطول (سم)",
  "admin.editUser.imageHint": "JPG أو PNG أو WebP — بحد أقصى 5 ميجابايت",
  "admin.editUser.languages": "اللغات",
  "admin.editUser.lookAlike": "يشبه",
  "admin.editUser.male": "ذكر",
  "admin.editUser.noImage": "لا توجد صورة",
  "admin.editUser.otherLanguage": "لغة أخرى",
  "admin.editUser.pantSize": "مقاس البنطال",
  "admin.editUser.phone": "الهاتف",
  "admin.editUser.physicalAttributes": "الصفات الجسدية",
  "admin.editUser.profileEnlarged": "صورة الملف الشخصي مكبّرة",
  "admin.editUser.profileImage": "صورة الملف الشخصي",
  "admin.editUser.ratesPer": "السعر لكل",
  "admin.editUser.removeLanguage": "إزالة اللغة",
  "admin.editUser.saveChanges": "حفظ التغييرات",
  "admin.editUser.selectField": "اختر...",
  "admin.editUser.selectGender": "اختر الجنس",
  "admin.editUser.selectTalentType": "اختر نوع الموهبة",
  "admin.editUser.shoeSize": "مقاس الحذاء",
  "admin.editUser.skinTone": "لون البشرة",
  "admin.editUser.specialization": "التخصص",
  "admin.editUser.specialties": "التخصصات",
  "admin.editUser.specifyLanguage": "يرجى تحديد اللغة",
  "admin.editUser.statusApproved": "موافق عليه",
  "admin.editUser.statusPending": "قيد الانتظار",
  "admin.editUser.statusRejected": "مرفوض",
  "admin.editUser.tShirtSize": "مقاس التيشيرت",
  "admin.editUser.talentDetails": "تفاصيل الموهبة",
  "admin.editUser.talentType": "نوع الموهبة",
  "admin.editUser.title": "تعديل المستخدم",
  "admin.editUser.weightKg": "الوزن (كجم)",
  "admin.editUser.whatsappNumber": "رقم الواتساب",

  // ── Admin: Gallery ─────────────────────────────────────────────────────────
  "admin.gallery.addPhotos": "إضافة صور",
  "admin.gallery.confirmDelete": "هل أنت متأكد أنك تريد حذف هذه الصورة؟",
  "admin.gallery.cropPhotoTitle": "قص الصورة",
  "admin.gallery.cropPhotoTitleWithMore": "قص الصورة (+{{count}} أخرى)",
  "admin.gallery.cropReplacementPhotoTitle": "قص صورة الاستبدال",
  "admin.gallery.deleteImage": "حذف الصورة",
  "admin.gallery.noImages": "لا توجد صور بعد",
  "admin.gallery.pendingUpload": "بانتظار الرفع",
  "admin.gallery.replaceImage": "استبدال الصورة",
  "admin.gallery.title": "المعرض",
  "admin.gallery.uploadPhotos": "رفع صور",
  "admin.gallery.uploading": "جارٍ الرفع...",

  // ── Admin: Project Type Modal ──────────────────────────────────────────────
  "admin.projectTypeModal.createTitle": "إنشاء نوع مشروع",
  "admin.projectTypeModal.editTitle": "تعديل نوع المشروع",
  "admin.projectTypeModal.eyebrow": "نوع المشروع",
  "admin.projectTypeModal.nameLabel": "الاسم",
  "admin.projectTypeModal.namePlaceholder": "مثال: جلسة تصوير أزياء",

  // ── Admin: Project Types Management ────────────────────────────────────────
  "admin.projectTypesManagement.createProjectType": "إنشاء نوع مشروع",
  "admin.projectTypesManagement.created": "تم الإنشاء",
  "admin.projectTypesManagement.deleteConfirmTitle": "حذف نوع المشروع هذا؟",
  "admin.projectTypesManagement.eyebrow": "أنواع المشاريع",
  "admin.projectTypesManagement.noProjectTypesFound": "لم يتم العثور على أنواع مشاريع",
  "admin.projectTypesManagement.noProjectTypesHint": "أنشئ أول نوع مشروع للبدء",
  "admin.projectTypesManagement.searchPlaceholder": "البحث في أنواع المشاريع...",
  "admin.projectTypesManagement.searchResults": "{{count}} نتيجة",
  "admin.projectTypesManagement.slug": "المعرّف النصي",
  "admin.projectTypesManagement.subtitle": "إدارة أنواع مشاريع طلبات الكاستينج",
  "admin.projectTypesManagement.title": "أنواع المشاريع",
  "admin.projectTypesManagement.totalProjectTypes": "إجمالي أنواع المشاريع",

  // ── Admin: Question Modal ──────────────────────────────────────────────────
  "admin.questionModal.activeHint": "الأسئلة النشطة تظهر للمستخدمين",
  "admin.questionModal.addTitle": "إضافة سؤال",
  "admin.questionModal.answerType": "نوع الإجابة",
  "admin.questionModal.closeModal": "إغلاق",
  "admin.questionModal.configureSubtitle": "قم بتهيئة تفاصيل السؤال أدناه",
  "admin.questionModal.creating": "جارٍ الإنشاء...",
  "admin.questionModal.editTitle": "تعديل السؤال",
  "admin.questionModal.questionText": "نص السؤال",
  "admin.questionModal.questionTextPlaceholder": "أدخل السؤال...",
  "admin.questionModal.questionTextRequired": "نص السؤال مطلوب",
  "admin.questionModal.updating": "جارٍ التحديث...",
  "admin.questionModal.yesNo": "نعم / لا",

  // ── Admin: Questions Management ────────────────────────────────────────────
  "admin.questionsManagement.addQuestion": "إضافة سؤال",
  "admin.questionsManagement.aria.activateQuestion": "تفعيل السؤال",
  "admin.questionsManagement.aria.deactivateQuestion": "إلغاء تفعيل السؤال",
  "admin.questionsManagement.aria.deleteQuestion": "حذف السؤال",
  "admin.questionsManagement.aria.editQuestion": "تعديل السؤال",
  "admin.questionsManagement.aria.nextPage": "الصفحة التالية",
  "admin.questionsManagement.aria.previousPage": "الصفحة السابقة",
  "admin.questionsManagement.empty.subtitle": "أضف أول سؤال للبدء",
  "admin.questionsManagement.empty.title": "لم يتم العثور على أسئلة",
  "admin.questionsManagement.pagination.showing": "عرض",
  "admin.questionsManagement.registration": "التسجيل",
  "admin.questionsManagement.searchPlaceholder": "البحث في الأسئلة...",
  "admin.questionsManagement.stats.total": "إجمالي الأسئلة",
  "admin.questionsManagement.subtitle": "إدارة أسئلة التسجيل",
  "admin.questionsManagement.table.created": "تاريخ الإنشاء",
  "admin.questionsManagement.table.question": "السؤال",
  "admin.questionsManagement.title": "إدارة الأسئلة",

  // ── Admin: Quotations Management ───────────────────────────────────────────
  "admin.quotationsManagement.empty.subtitle": "ستظهر طلبات عروض الأسعار هنا",
  "admin.quotationsManagement.empty.title": "لم يتم العثور على عروض أسعار",
  "admin.quotationsManagement.filter.allStatus": "كل الحالات",
  "admin.quotationsManagement.filter.approved": "موافق عليه",
  "admin.quotationsManagement.filter.pending": "قيد الانتظار",
  "admin.quotationsManagement.filter.rejected": "مرفوض",
  "admin.quotationsManagement.stats.pending": "قيد الانتظار",
  "admin.quotationsManagement.stats.approved": "موافق عليه",
  "admin.quotationsManagement.stats.rejected": "مرفوض",
  "admin.quotationsManagement.searchPlaceholder": "البحث في عروض الأسعار...",
  "admin.quotationsManagement.subtitle": "إدارة طلبات عروض أسعار العملاء",
  "admin.quotationsManagement.table.createdAt": "تاريخ الإنشاء",
  "admin.quotationsManagement.table.email": "البريد الإلكتروني",
  "admin.quotationsManagement.table.equipment": "المعدات",
  "admin.quotationsManagement.table.idea": "الفكرة",
  "admin.quotationsManagement.table.name": "الاسم",
  "admin.quotationsManagement.table.phone": "الهاتف",
  "admin.quotationsManagement.title": "إدارة عروض الأسعار",
  "admin.quotationsManagement.total": "الإجمالي",

  // ── Admin: Contact Messages ─────────────────────────────────────────────────
  "admin.contactMessages.title": "رسائل التواصل",
  "admin.contactMessages.subtitle": "الرسائل المرسلة من صفحة التواصل",
  "admin.contactMessages.total": "الإجمالي",
  "admin.contactMessages.stats.new": "جديدة",
  "admin.contactMessages.stats.read": "مقروءة",
  "admin.contactMessages.searchPlaceholder": "البحث في الرسائل...",
  "admin.contactMessages.filter.allStatus": "كل الحالات",
  "admin.contactMessages.empty.title": "لا توجد رسائل",
  "admin.contactMessages.empty.subtitle": "ستظهر هنا الرسائل المرسلة من نموذج التواصل",
  "admin.contactMessages.table.name": "الاسم",
  "admin.contactMessages.table.email": "البريد الإلكتروني",
  "admin.contactMessages.table.phone": "الهاتف",
  "admin.contactMessages.table.message": "الرسالة",
  "admin.contactMessages.table.createdAt": "تاريخ الاستلام",

  // ── Admin: Specialties Management ──────────────────────────────────────────
  "admin.specialtiesManagement.createSpecialty": "إنشاء تخصص",
  "admin.specialtiesManagement.created": "تم الإنشاء",
  "admin.specialtiesManagement.deleteConfirmTitle": "حذف هذا التخصص؟",
  "admin.specialtiesManagement.eyebrow": "التخصصات",
  "admin.specialtiesManagement.noSpecialtiesFound": "لم يتم العثور على تخصصات",
  "admin.specialtiesManagement.noSpecialtiesHint": "أنشئ أول تخصص للبدء",
  "admin.specialtiesManagement.searchPlaceholder": "البحث في التخصصات...",
  "admin.specialtiesManagement.searchResults": "{{count}} نتيجة",
  "admin.specialtiesManagement.subOptions": "خيارات فرعية",
  "admin.specialtiesManagement.subtitle": "إدارة تخصصات المواهب",
  "admin.specialtiesManagement.title": "التخصصات",
  "admin.specialtiesManagement.totalSpecialties": "إجمالي التخصصات",

  // ── Admin: Specialty Modal ─────────────────────────────────────────────────
  "admin.specialtyModal.createTitle": "إنشاء تخصص",
  "admin.specialtyModal.editTitle": "تعديل التخصص",
  "admin.specialtyModal.eyebrow": "تخصص",
  "admin.specialtyModal.nameLabel": "الاسم",
  "admin.specialtyModal.namePlaceholder": "مثال: راقص",
  "admin.specialtyModal.optionPlaceholder": "مثال: باليه",
  "admin.specialtyModal.removeOption": "إزالة الخيار",
  "admin.specialtyModal.subOptionsHint": "فئات فرعية اختيارية لهذا التخصص",
  "admin.specialtyModal.subOptionsLabel": "خيارات فرعية",

  // ── Admin: Trusted Brand Modal ─────────────────────────────────────────────
  "admin.trustedBrandModal.addTitle": "إضافة علامة تجارية موثوقة",
  "admin.trustedBrandModal.brandNameLabel": "اسم العلامة التجارية",
  "admin.trustedBrandModal.brandNamePlaceholder": "مثال: Nike",
  "admin.trustedBrandModal.editTitle": "تعديل العلامة التجارية الموثوقة",
  "admin.trustedBrandModal.eyebrow": "علامة تجارية موثوقة",
  "admin.trustedBrandModal.logoUrlLabel": "رابط الشعار",
  "admin.trustedBrandModal.logoUrlPlaceholder": "https://...",
  "admin.trustedBrandModal.preview": "معاينة",

  // ── Admin: Trusted Brands Management ───────────────────────────────────────
  "admin.trustedBrandsManagement.addBrand": "إضافة علامة تجارية",
  "admin.trustedBrandsManagement.deleteConfirmTitle": "حذف هذه العلامة التجارية؟",
  "admin.trustedBrandsManagement.eyebrow": "العلامات التجارية الموثوقة",
  "admin.trustedBrandsManagement.noBrandsFound": "لم يتم العثور على علامات تجارية",
  "admin.trustedBrandsManagement.noBrandsHint": "أضف أول علامة تجارية موثوقة للبدء",
  "admin.trustedBrandsManagement.noImage": "لا توجد صورة",
  "admin.trustedBrandsManagement.searchPlaceholder": "البحث في العلامات التجارية...",
  "admin.trustedBrandsManagement.searchResults": "{{count}} نتيجة",
  "admin.trustedBrandsManagement.subtitle": "إدارة شعارات العلامات التجارية الموثوقة",
  "admin.trustedBrandsManagement.title": "العلامات التجارية الموثوقة",
  "admin.trustedBrandsManagement.totalBrands": "إجمالي العلامات التجارية",

  // ── Admin: User Modal (validation) ─────────────────────────────────────────
  "admin.userModal.companyRequired": "الشركة مطلوبة",
  "admin.userModal.dobRequired": "تاريخ الميلاد مطلوب",
  "admin.userModal.emailRequired": "البريد الإلكتروني مطلوب",
  "admin.userModal.firstNameRequired": "الاسم الأول مطلوب",
  "admin.userModal.fixHighlightedFields": "يرجى تصحيح الحقول المظللة",
  "admin.userModal.invalidEmail": "يرجى إدخال بريد إلكتروني صالح",
  "admin.userModal.invalidPhone": "يرجى إدخال رقم هاتف صالح",
  "admin.userModal.invalidWhatsapp": "يرجى إدخال رقم واتساب صالح",
  "admin.userModal.lastNameRequired": "اسم العائلة مطلوب",
  "admin.userModal.passwordRequired": "كلمة المرور مطلوبة",
  "admin.userModal.passwordsDontMatch": "كلمتا المرور غير متطابقتين",
  "admin.userModal.selectContentCreatorTypeError": "يرجى اختيار نوع واحد على الأقل من أنواع صانعي المحتوى",
  "admin.userModal.selectTalentTypeError": "يرجى اختيار نوع الموهبة",

  // ── Admin: Users Management ────────────────────────────────────────────────
  "admin.usersManagement.addNewUser": "إضافة مستخدم جديد",
  "admin.usersManagement.allRoles": "كل الأدوار",
  "admin.usersManagement.clickToApprove": "انقر للموافقة",
  "admin.usersManagement.clickToSetPending": "انقر لتعيينه قيد الانتظار",
  "admin.usersManagement.columnEmail": "البريد الإلكتروني",
  "admin.usersManagement.columnJoined": "تاريخ الانضمام",
  "admin.usersManagement.columnPhone": "الهاتف",
  "admin.usersManagement.columnRole": "الدور",
  "admin.usersManagement.columnUser": "المستخدم",
  "admin.usersManagement.deleteUserTitle": "حذف هذا المستخدم؟",
  "admin.usersManagement.editFullProfile": "تعديل الملف الشخصي الكامل",
  "admin.usersManagement.next": "التالي",
  "admin.usersManagement.pageOf": "صفحة {{page}} من {{totalPages}}",
  "admin.usersManagement.prev": "السابق",
  "admin.usersManagement.roleAdmin": "مسؤول",
  "admin.usersManagement.roleClient": "عميل",
  "admin.usersManagement.roleTalent": "موهبة",
  "admin.usersManagement.searchPlaceholder": "البحث عن مستخدمين...",
  "admin.usersManagement.showingResults": "عرض {{from}} إلى {{to}} من أصل {{total}} نتيجة",
  "admin.usersManagement.statAdmins": "المسؤولون",
  "admin.usersManagement.statClients": "العملاء",
  "admin.usersManagement.statTalents": "المواهب",
  "admin.usersManagement.statTotal": "إجمالي المستخدمين",
  "admin.usersManagement.subtitle": "إدارة جميع مستخدمي المنصة",
  "admin.usersManagement.title": "إدارة المستخدمين",

  // ── Admin: Work Modal ──────────────────────────────────────────────────────
  "admin.workModal.addAward": "إضافة جائزة",
  "admin.workModal.awardPlaceholder": "مثال: أفضل تصوير سينمائي",
  "admin.workModal.awards": "الجوائز",
  "admin.workModal.browse": "تصفح",
  "admin.workModal.category": "الفئة",
  "admin.workModal.categoryPlaceholder": "مثال: إعلان تجاري، فيديو موسيقي",
  "admin.workModal.change": "تغيير",
  "admin.workModal.client": "العميل",
  "admin.workModal.clientPlaceholder": "اسم العميل",
  "admin.workModal.closeModal": "إغلاق",
  "admin.workModal.createWork": "إنشاء عمل",
  "admin.workModal.currentImage": "الصورة الحالية",
  "admin.workModal.currentVideo": "الفيديو الحالي",
  "admin.workModal.descriptionPlaceholder": "اكتب وصفًا مختصرًا...",
  "admin.workModal.editWork": "تعديل العمل",
  "admin.workModal.fillDetails": "املأ التفاصيل أدناه",
  "admin.workModal.image": "صورة",
  "admin.workModal.imageTooLarge": "الصورة كبيرة جدًا (الحد الأقصى {{maxMb}} ميجابايت)",
  "admin.workModal.newWork": "عمل جديد",
  "admin.workModal.noFileSelected": "لم يتم اختيار ملف",
  "admin.workModal.processing": "جارٍ المعالجة...",
  "admin.workModal.removeAward": "إزالة الجائزة",
  "admin.workModal.removeFile": "إزالة الملف",
  "admin.workModal.replace": "استبدال",
  "admin.workModal.saveChanges": "حفظ التغييرات",
  "admin.workModal.titleLabel": "العنوان",
  "admin.workModal.titlePlaceholder": "أدخل عنوانًا",
  "admin.workModal.updateDetails": "تحديث التفاصيل",
  "admin.workModal.uploading": "جارٍ الرفع...",
  "admin.workModal.video": "فيديو",
  "admin.workModal.videoTooLarge": "حجم ملف الفيديو كبير جدًا",
  "admin.workModal.year": "السنة",

  // ── Admin: Works Management ────────────────────────────────────────────────
  "admin.worksManagement.addFirstWork": "أضف أول عمل",
  "admin.worksManagement.addNewWork": "إضافة عمل جديد",
  "admin.worksManagement.addWork": "إضافة عمل",
  "admin.worksManagement.added": "تمت الإضافة",
  "admin.worksManagement.awards": "الجوائز",
  "admin.worksManagement.categories": "الفئات",
  "admin.worksManagement.clear": "مسح",
  "admin.worksManagement.client": "العميل",
  "admin.worksManagement.deleteWork": "حذف العمل",
  "admin.worksManagement.editWork": "تعديل العمل",
  "admin.worksManagement.image": "صورة",
  "admin.worksManagement.noMediaAttached": "لا توجد وسائط مرفقة",
  "admin.worksManagement.noWorksFound": "لم يتم العثور على أعمال",
  "admin.worksManagement.portfolioHub": "مركز الأعمال",
  "admin.worksManagement.searchPlaceholder": "البحث في الأعمال...",
  "admin.worksManagement.subtitle": "إدارة معرض أعمالك",
  "admin.worksManagement.title": "إدارة الأعمال",
  "admin.worksManagement.totalWorks": "إجمالي الأعمال",
  "admin.worksManagement.video": "فيديو",

  // ── Common (extra) ─────────────────────────────────────────────────────────
  "common.unknownError": "حدث خطأ غير معروف",

  // ── SweetAlert dialogs ─────────────────────────────────────────────────────
  "swal.blog.approvedText": "تمت الموافقة على المقال.",
  "swal.blog.approvedTitle": "تمت الموافقة!",
  "swal.blog.deleteText": "لا يمكن التراجع عن هذا الإجراء.",
  "swal.blog.deleteTitle": "حذف هذا المقال؟",
  "swal.blog.errorTitle": "خطأ",
  "swal.blog.goToBlogsButton": "الذهاب إلى المدونة",
  "swal.blog.loadFailedText": "فشل تحميل المقالات. يرجى المحاولة مرة أخرى.",
  "swal.blog.rejectInputLabel": "سبب الرفض",
  "swal.blog.rejectInputPlaceholder": "أدخل سببًا...",
  "swal.blog.rejectTitle": "رفض هذا المقال؟",
  "swal.blog.rejectedTitle": "مرفوض",
  "swal.blog.saveFailedText": "فشل حفظ المقال. يرجى المحاولة مرة أخرى.",
  "swal.blog.successTitle": "تم بنجاح!",
  "swal.blog.validationErrorText": "يرجى ملء جميع الحقول المطلوبة.",
  "swal.blog.validationErrorTitle": "خطأ في التحقق",
  "swal.content.createdTitle": "تم إنشاء المحتوى بنجاح!",
  "swal.content.updatedTitle": "تم تحديث المحتوى بنجاح!",
  "swal.content.validationErrorText": "يرجى ملء جميع الحقول المطلوبة.",
  "swal.content.validationErrorTitle": "خطأ في التحقق",
  "swal.question.deleteConfirmButton": "نعم، احذفه",
  "swal.question.deleteText": "لا يمكن التراجع عن هذا الإجراء.",
  "swal.question.deleteTitle": "حذف هذا السؤال؟",

  // ── Toasts ─────────────────────────────────────────────────────────────────
  "toast.album.deleteFailed": "فشل حذف الألبوم",
  "toast.album.deleted": "تم حذف الألبوم",
  "toast.album.imageRequired": "يرجى اختيار صورة",
  "toast.album.imagesAdded": "تمت إضافة الصور",
  "toast.album.loadFailed": "فشل تحميل الألبومات",
  "toast.album.saveFailed": "فشل حفظ الألبوم",
  "toast.album.saved": "تم حفظ الألبوم",
  "toast.blog.approveFailed": "فشلت الموافقة على المقال",
  "toast.blog.created": "تم إنشاء المقال",
  "toast.blog.deleteFailed": "فشل حذف المقال",
  "toast.blog.loadFailed": "فشل تحميل المقالات",
  "toast.blog.rejectFailed": "فشل رفض المقال",
  "toast.blog.updated": "تم تحديث المقال",
  "toast.brief.loadFailed": "فشل تحميل طلبات الكاستينج",
  "toast.brief.statusUpdated": "تم تحديث الحالة إلى {{status}}",
  "toast.brief.updateFailed": "فشل تحديث الحالة",
  "toast.content.deleteFailed": "فشل حذف المحتوى",
  "toast.content.deleted": "تم حذف المحتوى",
  "toast.content.loadFailed": "فشل تحميل المحتوى",
  "toast.content.saveFailed": "فشل حفظ المحتوى",
  "toast.content.saved": "تم حفظ المحتوى",
  "toast.content.titleCategoryRequired": "العنوان والفئة مطلوبان",
  "toast.gallery.deleteFailed": "فشل حذف الصورة",
  "toast.gallery.exceedsSize": "حجم الملف يتجاوز الحد الأقصى",
  "toast.gallery.imageDeleted": "تم حذف الصورة",
  "toast.gallery.imageReplaced": "تم استبدال الصورة",
  "toast.gallery.imagesUploaded": "تم رفع الصور",
  "toast.gallery.replaceFailed": "فشل استبدال الصورة",
  "toast.gallery.unsupportedFormat": "صيغة الملف غير مدعومة",
  "toast.gallery.uploadFailed": "فشل رفع الصورة",
  "toast.projectType.created": "تم إنشاء نوع المشروع",
  "toast.projectType.deleteFailed": "فشل حذف نوع المشروع",
  "toast.projectType.deleted": "تم حذف نوع المشروع",
  "toast.projectType.loadFailed": "فشل تحميل أنواع المشاريع",
  "toast.projectType.nameRequired": "الاسم مطلوب",
  "toast.projectType.saveFailed": "فشل حفظ نوع المشروع",
  "toast.projectType.updated": "تم تحديث نوع المشروع",
  "toast.question.created": "تم إنشاء السؤال",
  "toast.question.deleteFailed": "فشل حذف السؤال",
  "toast.question.deleted": "تم حذف السؤال",
  "toast.question.loadFailed": "فشل تحميل الأسئلة",
  "toast.question.saveFailed": "فشل حفظ السؤال",
  "toast.question.textRequired": "نص السؤال مطلوب",
  "toast.question.toggleFailed": "فشل تحديث حالة السؤال",
  "toast.question.updated": "تم تحديث السؤال",
  "toast.quotation.deleteFailed": "فشل حذف عرض السعر",
  "toast.quotation.deleted": "تم حذف عرض السعر",
  "toast.quotation.loadFailed": "فشل تحميل عروض الأسعار",
  "toast.quotation.statusUpdateFailed": "فشل تحديث الحالة",
  "toast.quotation.statusUpdated": "تم تحديث الحالة",
  "toast.quotation.updateFailed": "فشل تحديث عرض السعر",
  "toast.quotation.updated": "تم تحديث عرض السعر",
  "toast.contactMessage.loadFailed": "فشل تحميل رسائل التواصل",
  "toast.contactMessage.updateFailed": "فشل تحديث الرسالة",
  "toast.contactMessage.deleted": "تم حذف الرسالة",
  "toast.contactMessage.deleteFailed": "فشل حذف الرسالة",
  "toast.specialty.created": "تم إنشاء التخصص",
  "toast.specialty.deleteFailed": "فشل حذف التخصص",
  "toast.specialty.deleted": "تم حذف التخصص",
  "toast.specialty.loadFailed": "فشل تحميل التخصصات",
  "toast.specialty.nameRequired": "الاسم مطلوب",
  "toast.specialty.saveFailed": "فشل حفظ التخصص",
  "toast.specialty.updated": "تم تحديث التخصص",
  "toast.testimonial.loadFailed": "فشل تحميل الشهادات",
  "toast.trustedBrand.added": "تمت إضافة العلامة التجارية",
  "toast.trustedBrand.deleteFailed": "فشل حذف العلامة التجارية",
  "toast.trustedBrand.deleted": "تم حذف العلامة التجارية",
  "toast.trustedBrand.loadFailed": "فشل تحميل العلامات التجارية",
  "toast.trustedBrand.logoInvalidUrl": "يرجى إدخال رابط شعار صالح",
  "toast.trustedBrand.logoRequired": "الشعار مطلوب",
  "toast.trustedBrand.nameRequired": "الاسم مطلوب",
  "toast.trustedBrand.saveFailed": "فشل حفظ العلامة التجارية",
  "toast.trustedBrand.updated": "تم تحديث العلامة التجارية",
  "toast.user.approved": "تمت الموافقة على المستخدم",
  "toast.user.createFailed": "فشل إنشاء المستخدم",
  "toast.user.created": "تم إنشاء المستخدم",
  "toast.user.deleteFailed": "فشل حذف المستخدم",
  "toast.user.deleted": "تم حذف المستخدم",
  "toast.user.imageTooLarge": "الصورة كبيرة جدًا",
  "toast.user.imageUploadFailed": "فشل رفع الصورة",
  "toast.user.invalidEmail": "يرجى إدخال بريد إلكتروني صالح",
  "toast.user.invalidPhone": "يرجى إدخال رقم هاتف صالح",
  "toast.user.invalidWhatsapp": "يرجى إدخال رقم واتساب صالح",
  "toast.user.loadFailed": "فشل تحميل المستخدم",
  "toast.user.loadListFailed": "فشل تحميل المستخدمين",
  "toast.user.profileImageUpdated": "تم تحديث صورة الملف الشخصي",
  "toast.user.saveFailed": "فشل حفظ المستخدم",
  "toast.user.setPending": "تم تعيين المستخدم قيد الانتظار",
  "toast.user.statusUpdateFailed": "فشل تحديث الحالة",
  "toast.user.unsupportedImageFormat": "صيغة الصورة غير مدعومة",
  "toast.user.updated": "تم تحديث المستخدم",
  "toast.work.deleteFailed": "فشل حذف العمل",
  "toast.work.deleted": "تم حذف العمل",
  "toast.work.loadFailed": "فشل تحميل الأعمال",
  "toast.work.saveFailed": "فشل حفظ العمل",
  "toast.work.saved": "تم حفظ العمل",
  "toast.work.titleRequired": "العنوان مطلوب",

  // ── Shared: Language / Dialect Select ─────────────────────────────────────
  "shared.languageDialectSelect.languages": "اللغات *",
  "shared.languageDialectSelect.dialectAccent": "اللهجة / اللكنة",
  "shared.languageDialectSelect.otherLanguageLabel": "لغة أخرى — يرجى التحديد",
  "shared.languageDialectSelect.otherLanguagePlaceholder": "أدخل لغتك",

  // ── Shared: Phone Field ────────────────────────────────────────────────────
  "shared.phoneField.defaultLabel": "الهاتف",
  "shared.phoneField.alreadyRegistered": "رقم الهاتف هذا مسجل بالفعل.",
  "shared.phoneField.checking": "جارٍ التحقق من رقم الهاتف…",
  "shared.phoneField.invalid": "أدخل رقم هاتف صالحًا للدولة المحددة.",

  // ── Shared: Location Select (Country / State / City) ──────────────────────
  "shared.countryStateSelect.country": "الدولة",
  "shared.countryStateSelect.selectCountry": "اختر الدولة",
  "shared.countryStateSelect.state": "المحافظة / الولاية",
  "shared.countryStateSelect.selectState": "اختر المحافظة / الولاية",
  "shared.countryStateSelect.selectCountryFirst": "اختر الدولة أولاً",
  "shared.countryStateSelect.noStatesAvailable": "لا توجد محافظات متاحة",
};
